import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Spinner,
  Table,
  Badge,
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
import { saveAs } from "file-saver"
import ButtonSpinner from "components/ButtonSpinner"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"
//components
import * as eventClientAction from "../../../store/bXl3b3Jrc3Bob3Rv/actions"
import Breadcrumbs from "components/Common/Breadcrumb"
import * as crmManageClientAction from "../../../store/Y3JtTWFuYWdlQ2xpZW50/actions"
import api from "helpers/Api"
import { ToastContainer, toast } from "react-toastify"
import SimpleReactValidator from "simple-react-validator"

const CrmManageClientDetails = (props) => {
  const title = "Crm Manage Client"
  const { dispatch, searchBtnStyle } = props
  useEffect(() => {
    dispatch(crmManageClientAction.loadRecordsMetaData())
    dispatch(
      crmManageClientAction.loadCrmManageClient({
        page: 1,
        limit: 50,
        isOperationStatus: true,
      })
    )
  }, [])
  //React Validations
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  const simpleEmpValidator = useRef(new SimpleReactValidator())
  const simpleCrmValidator = useRef(new SimpleReactValidator())
  const simpleProductValidator = useRef(new SimpleReactValidator())
  const simpleEwValidator = useRef(new SimpleReactValidator())
  //empid
  const empId = localStorage.getItem("empId")

  const specificDispatch = useDispatch()

  const update = useSelector((state) => state.crmManageClient)

  const {
    recordsMetaData = {},
    crmManageClient_details = [],
    crmError,
    crmSuccess,
    mainEvent_data = [],
  } = update

  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)
  const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const eta =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.crmETA
      ? dateLogin.setting.crmETA
      : !isEmpty(user) && user.setting && user.setting.crmETA
        ? user.setting.crmETA
        : ""

  const etaValue = eta && eta ? eta : ""
  const [alertModal, setAlertModal] = useState(false)
  const [copyAlertModal, setCopyAlertModal] = useState(false)
  const [commonAlertModal, setCommonAlertModal] = useState(false)
  //crm manage client filter initial state
  const [crmManageClientData, setCrmManageClientData] = useState({
    leadNo: "",
    clientCode: "",
    fromDate: "",
    toDate: "",
    assignedFromDate: "",
    assignedToDate: "",
    brideName: "",
    groomName: "",
    productName: "",
    openFollowupCount: ""
  })
  const [deliverableStatus, setDeliverableStatus] = useState([])
  const [products, setProducts] = useState([])
  const [ewName, setEwName] = useState([])
  //handle change
  const handleChange = async (e) => {
    setCrmManageClientData({
      ...crmManageClientData,
      [e.target.name]: e.target.value,
    })
  }
  //inprogress checkbox
  const [inProgress, setInProgress] = useState("")

  const statusList = [
    {
      label: "INPROGRESS",
      value: true,
    },
  ]

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setInProgress(value)
    } else {
      setInProgress(false)
    }
  }

  //inprogress checkbox
  const [onlyEngagement, setOnlyEngagement] = useState("")

  const statusListEngage = [
    {
      label: "Only Engagement",
      value: true,
    },
  ]

  const handleStatusEngageChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setOnlyEngagement(value)
    } else {
      setOnlyEngagement(false)
    }
  }
  const [clearanceStatus, setClearanceStatus] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  // edit column modal
  const [columnModal, setColumnModal] = useState(false)
  const [agentKey, setAgentKey] = useState(false)
  const [openOperators, setOpenOperators] = useState([])
  //reset functionalities
  const resetForm = () => {
    setEvents([])
    setSearchInput("")
    setSalesAgent([])
    setAgent([])
    setDataCopyStatus([])
    setOnlyEngagement(false)
    setClearanceStatus([])
    setAgentKey(true)
    setProducts([])
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setSearchValueList({
      page: 1,
      limit: 50,
      isOperationStatus: true,
    })
    setInProgress(false)
    setOpenOperators([])
    setCrmManageClientData({
      fromDate: "",
      toDate: "",
      leadNo: "",
      assignedFromDate: "",
      assignedToDate: "",
      clientCode: "",
      brideName: "",
      groomName: "",
      openFollowupCount: ""
    })
    setEwName([])
    setDeliverableStatus([])
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoading(false)
    }, 2000)
    dispatch(
      crmManageClientAction.loadCrmManageClient({
        page: 1,
        limit: 50,
        isOperationStatus: true,
      })
    )
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [agent, setAgent] = useState([])
  //Search value
  const [searchValueList, setSearchValueList] = useState({})
  const [leadId, setLeadId] = useState("")

  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const searchValue =
    !isEmpty(searchValueList) && isEmpty(searchInput)
      ? searchValueList
      : isEmpty(searchValueList) && isEmpty(searchInput)
        ? {
          page: pageChange ? pageCount : 1,
          limit: 50,
          isOperationStatus: true,
        }
        : {
          page: pageChange ? pageCount : 1,
          limit: 50,
          isOperationStatus: true,
          searchFilter: searchInput,
        }
  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [dormantModal, setDormantModal] = useState(false)
  const [dormantData, setDormantData] = useState({
    remarks: "",
  })
  const [dataCopyStatus, setDataCopyStatus] = useState([])
  const handleDormantChange = (e) => {
    setDormantData({ ...dormantData, [e.target.name]: e.target.value })
  }
  const [clientType, setClientType] = useState([])
  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchEvent = events && events ? events.value : ""
    var searchDataCopy = dataCopyStatus && dataCopyStatus ? dataCopyStatus.value : ""
    var searchLeadNo = crmManageClientData.leadNo
      ? crmManageClientData.leadNo
      : ""
    var searchFromDate =
      crmManageClientData && crmManageClientData.fromDate
        ? moment(crmManageClientData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      crmManageClientData && crmManageClientData.toDate
        ? moment(crmManageClientData.toDate).format("YYYY-MM-DD")
        : ""
    var searchEmp = agent && agent ? agent.value : ""
    var searchEwName = !isEmpty(ewName) ? ewName.value : ""
    var searchAssignedFromDate =
      crmManageClientData && crmManageClientData.assignedFromDate
        ? moment(crmManageClientData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      crmManageClientData && crmManageClientData.assignedToDate
        ? moment(crmManageClientData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchClientCode = crmManageClientData.clientCode
      ? crmManageClientData.clientCode
      : ""
    var searchGroom =
      crmManageClientData && crmManageClientData.groomName
        ? crmManageClientData.groomName
        : ""
    var searchBride =
      crmManageClientData && crmManageClientData.brideName
        ? crmManageClientData.brideName
        : ""
    var searchOpenFollowup =
      crmManageClientData &&
        crmManageClientData.openFollowupCount &&
        crmManageClientData.openFollowupCount !== undefined
        ? crmManageClientData.openFollowupCount === "0"
          ? 0
          : parseInt(crmManageClientData.openFollowupCount)
        : ""

    var searchOperators = !isEmpty(openOperators) ? openOperators.value : ""
    var searchProductName = !isEmpty(products) ? products.value : ""
    var searchDeliverable =
      !isEmpty(deliverableStatus) && deliverableStatus.value
    var searchClearance =
      !isEmpty(clearanceStatus) && clearanceStatus.value
    var searchInProgress = inProgress === true ? "INPROGRESS" : ""
    var searchEngage = onlyEngagement == true ? true : ""

    var searchClientType = !isEmpty(clientType) ? clientType.value : ""
    var searchvalue = {}
    if (searchClientType) {
      searchvalue.clientType = searchClientType
    }

    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    searchvalue.isOperationStatus = true
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchDataCopy) {
      searchvalue.dataCopyStatus = searchDataCopy
    }

    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchEmp) {
      searchvalue.empId = searchEmp
    }
    if (searchEwName) {
      searchvalue.EWId = searchEwName
    }
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }
    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchProductName) {
      searchvalue.productCategoryId = searchProductName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    if (searchClientCode) {
      searchvalue.clientCode = searchClientCode
    }
    if (searchClearance) {
      searchvalue.paymentType = searchClearance
    }
    if (searchInProgress) {
      searchvalue.subStatus = searchInProgress
    }
    if (searchEngage) {
      searchvalue.onlyEngagement = searchEngage
    }

    if (searchOpenFollowup !== "" && searchOpenFollowup !== undefined && searchOpenFollowup !== null) {
      searchvalue.openFollowupCount = searchOpenFollowup
    }

    if (searchOperators) {
      searchvalue.openOperators = searchOperators
    }
    setSearchValueList(searchvalue)
    specificDispatch(crmManageClientAction.loadCrmManageClient(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  //crm assign

  const [crmData, setCrmData] = useState({
    notes: "",
  })

  const handleNotes = (e) => {
    setCrmData({ ...crmData, [e.target.name]: e.target.value })
  }

  const [employee, setEmployee] = useState([])
  const [multiEmployee, setMultiEmployee] = useState([])
  //reset
  const [multiCrmData, setMultiCrmData] = useState({
    note: "",
  })
  const handleMultiNotes = (e) => {
    setMultiCrmData({ ...multiCrmData, [e.target.name]: e.target.value })
  }

  //expand crm
  const [expandCrmData, setExpandCrmData] = useState({
    notes: "",
  })

  const handleExpandNotes = (e) => {
    setExpandCrmData({ ...expandCrmData, [e.target.name]: e.target.value })
  }
  const [crmExpandModal, setCrmExpandModal] = useState(false)
  const [expandEmployee, setExpandEmployee] = useState([])
  const [expandCrmDetails, setExpandCrmDetails] = useState([])
  const [expandCrmButton, setExpandCrmButton] = useState(false)

  const [crmAssignModal, setCrmAssignModal] = useState(false)
  const [crmAssignData, setCrmAssignData] = useState("")

  const [multiCrmModal, setMultiCrmModal] = useState(false)
  const [crmAssignDetails, setCrmAssignDetails] = useState([])
  const [crmAssignButton, setCrmAssignButton] = useState(false)
  const [unAssignButton, setUnAssignButton] = useState(false)
  //assigned history modal
  const [historyModal, setHistoryModal] = useState(false)

  const [clearanceModal, setClearanceModal] = useState(false)
  const [clearanceDetails, setClearanceDetails] = useState("")
  const [clearanceHistoryModal, setClearanceHistoryModal] = useState(false)
  const [clearanceHistoryDetails, setClearanceHistoryDetails] = useState("")
  const [deliverablesModal, setDeliverablesModal] = useState(false)
  const [deliverablesData, setDeliverablesData] = useState([])
  const [unAssignLeadId, setUnassignLeadId] = useState("")
  const [multiUnAssignModal, setMultiUnAssignModal] = useState(false)
  // update deliverable
  const [processData, setProcessData] = useState({
    notes: "",
  })
  const handleNotesChange = (e) => {
    setProcessData({ ...processData, [e.target.name]: e.target.value })
  }
  const [operationStatus, setOperationStatus] = useState([])
  const operationStatusOptions = [
    { label: "EW QC Completed", value: "PS42" },
    { label: "Client Changes", value: "PS45" },
    { label: "Client Rework", value: "PS40" },
    { label: "Shared to client", value: "PS46" },
    { label: "Client Pending", value: "PS66" },
    { label: "Not Applicable", value: "PS69" },
  ]
  const [operationAttachment, setOperationAttachment] = useState([])

  const operationAttachmentChange = async (e) => {
    if (e.target.files) {
      var file = e.target.files
      var fileArrayDetails = Array.from(file)
      setOperationAttachment(file)
      var teamUploadValue = operationAttachment

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setOperationAttachment(teamUploadValue)
          }
        })
      }
    }
  }

  // const [sortDirection] = useState("asc")

  // const postInitialArray =
  //   !isEmpty(crmManageClient_details) &&
  //   crmManageClient_details &&
  //   crmManageClient_details.data.length > 0
  //     ? crmManageClient_details.data
  //     : []
  // const sortingTable = [...postInitialArray]

  // const dataWithDate = sortingTable.filter((item) => item.postCrmAssignedDate)
  // const dataWithoutDate = sortingTable.filter(
  //   (item) => !item.postCrmAssignedDate
  // )

  // const sortedData = [
  //   ...dataWithDate.sort((a, b) => {
  //     const dateA = new Date(a.postCrmAssignedDate)
  //     const dateB = new Date(b.postCrmAssignedDate)
  //     return sortDirection === "asc" ? dateA - dateB : dateB - dateA
  //   }),
  //   ...dataWithoutDate, // Append data without date as is
  // ]

  const [updateProcess, setUpdateProcess] = useState("")
  const [processStatusModal, setProcessStatusModal] = useState(false)
  const [processHistoryDetails, setProcessHistoryDetails] = useState("")
  const [plEmployee, setPlEmployee] = useState([])
  let slNo = 0
  const [unassignedModal, setUnassignedModal] = useState(false)
  //event
  const [eventServiceModal, setEventServiceModal] = useState(false)

  //printable
  const [printPlData, setPrintPlData] = useState({
    noOfSheets: "",
    noOfWrapperSheets: "",
    printFileLink: "",
    additionalProductRemarks: "",
    packageInclusionNumber: "",
    packegeInclusionRemarks: "",
    deliveryAddress: "",
  })
  const handlePrintChange = (e) => {
    setPrintPlData({ ...printPlData, [e.target.name]: e.target.value })
  }
  const clearPrintPlData = () => {
    setPrintPlData({
      noOfSheets: "",
      noOfWrapperSheets: "",
      printFileLink: "",
      additionalProductRemarks: "",
      packageInclusionNumber: "",
      packegeInclusionRemarks: "",
      deliveryAddress: "",
    })
  }
  const [printable, setPrintable] = useState("")
  const [printableData, setPrintableData] = useState("")
  const [ecAttachmentModal, setEcAttachmentModal] = useState(false)
  const [ecAttachmentDetails, setEcAttachmentDetails] = useState("")
  const [salesAttachmentModal, setSalesAttachmentModal] = useState(false)
  const [salesAttachmentDetails, setSalesAttachmentDetails] = useState("")
  const [isEscalationModal, setIsEscalationModal] = useState(false)

  const crmManageClientDataTable = !isEmpty(crmManageClient_details)
    ? crmManageClient_details.data.map((data, index) => {
      slNo = slNo + 1

      const paymentStatus = !isEmpty(data.leadClearance)
        ? data.leadClearance.type
        : ""

      const deliverableFilterArray = data.deliverableDetails &&
        data.deliverableDetails.length > 0
        ? data.deliverableDetails.map((client) => {
          if (
            searchValueList.productCategoryId ==
            client.productCategoryId &&
            searchValueList.productionprocessstatus ==
            client.productionprocessstatus
          ) {
            return client
          }
        })
        : []
      const deliverableCategoryArray =
        data.deliverableDetails.length > 0
          ? data.deliverableDetails.map((client) => {
            if (
              searchValueList.productCategoryId == client.productCategoryId
            ) {
              return client
            }
          })
          : []
      const deliverableProcessStatusArray =
        data.deliverableDetails.length > 0
          ? data.deliverableDetails.map((client) => {
            if (
              searchValueList.productionprocessstatus ==
              client.productionprocessstatus
            ) {
              return client
            }
          })
          : []

      const deliverableCategoryArrayDetails =
        deliverableCategoryArray && deliverableCategoryArray.length > 0
          ? deliverableCategoryArray.filter((data) => data != undefined)
          : []
      const deliverableFilterArrayDetails =
        deliverableFilterArray && deliverableFilterArray.length > 0
          ? deliverableFilterArray.filter((data) => data != undefined)
          : []
      const deliverableProcessStatusArrayDetails =
        deliverableProcessStatusArray &&
          deliverableProcessStatusArray.length > 0
          ? deliverableProcessStatusArray.filter((data) => data != undefined)
          : []

      const deliverableCount =
        !isEmpty(searchValueList.productCategoryId) &&
          !isEmpty(searchValueList.productionprocessstatus)
          ? deliverableFilterArrayDetails.length
          : !isEmpty(searchValueList.productCategoryId) &&
            isEmpty(searchValueList.productionprocessstatus)
            ? deliverableCategoryArrayDetails.length
            : isEmpty(searchValueList.productCategoryId) &&
              !isEmpty(searchValueList.productionprocessstatus)
              ? deliverableProcessStatusArrayDetails.length
              : data.deliverableDetails.length > 0
                ? data.deliverableDetails.length
                : 0

      const eventNameValue = !isEmpty(data.eventName)
        ? data.eventName.map((m) => m).join(",")
        : "--"
      const eventDateValue = !isEmpty(data.eventDate)
        ? data.eventDate
          .map((m) => moment(m).format(dateFormat))
          .reduce((result, date, index) => {

            const groupIndex = Math.floor(index / 3)
            result[groupIndex] = result[groupIndex] || []
            result[groupIndex].push(date)
            return result
          }, [])
          .map((group) => group.join(", "))
          .join("\n")
        : "--"

      const eventVenue = !isEmpty(data.eventVenueName)
        ? data.eventVenueName.map((m) => m).join(",")
        : "--"
      const dataCopyColorCode =
        data.dataCopyStatus == "COMPLETED" ? "#28a745" : "#dc3545"


      const pendingDeliverableCount = data && data.deliverableDetails.length > 0 ?
        data.deliverableDetails.filter((status) => status.productionprocessstatus != "PS69" && status.productionprocessstatus != "PS46") : []

      const pendingDeliverableCountValue = !isEmpty(pendingDeliverableCount) ? pendingDeliverableCount.length : 0
      return {
        rowData: data,
        _id: data.leadId,
        sNo: slNo,
        leadNo: data.leadNo,
        leadId: data.leadId,
        branchId: data.branchId,
        branchName: data.branchName ? data.branchName : "--",
        clientName: data.clientName ? data.clientName : "--",
        clientCode: data.clientCode ? data.clientCode : "--",
        companyId: data.companyId,
        companyName: data.companyName ? data.companyName : "--",
        deliverables: deliverableCount,
        isPrintable: data.isPrintable,
        leadDate: data.leadDate
          ? moment(data.leadDate).format(dateFormat)
          : "",
        overallStatus: data.overAllStatus ? data.overAllStatus : "--",
        deliverableDetails:
          !isEmpty(searchValueList.productCategoryId) &&
            !isEmpty(searchValueList.productionprocessstatus)
            ? deliverableFilterArrayDetails
            : !isEmpty(searchValueList.productCategoryId) &&
              isEmpty(searchValueList.productionprocessstatus)
              ? deliverableCategoryArrayDetails
              : isEmpty(searchValueList.productCategoryId) &&
                !isEmpty(searchValueList.productionprocessstatus)
                ? deliverableProcessStatusArrayDetails
                : data.deliverableDetails,
        deliverableDetailsArray: data.deliverableDetails,
        crmAssign: (
          <>
            <div className="d-flex flex-row align-items-center">
              <Button
                className="btn btn-warning text-nowrap"
                onClick={() => {
                  setCrmAssignModal(true)
                  setCrmAssignData(data)
                  handleClearModal()
                }}
              >
                {data.postCrmAssignedName
                  ? data.postCrmAssignedName
                  : "CRM Assign"}
              </Button>
              <div style={{ marginLeft: "10px" }}>
                <Input
                  type="checkbox"
                  checked={crmAssignDetails.some(
                    (item) => item.leadId === data.leadId
                  )}
                  style={{ width: "15px", height: "15px" }}
                  onChange={(e) => {
                    if (
                      e.target.checked &&
                      !crmAssignDetails.find(
                        (item) => item.leadId === data.leadId
                      )
                    ) {
                      setCrmAssignDetails([...crmAssignDetails, data])
                    } else {
                      setCrmAssignDetails(
                        crmAssignDetails.filter(
                          (item) => item.leadId !== data.leadId
                        )
                      )
                    }
                    const anyChecked = crmAssignDetails.some(
                      (item) => item.leadId !== data.leadId
                    )
                    setCrmAssignButton(anyChecked)
                    setUnAssignButton(anyChecked)
                  }}
                />
              </div>
              <div className="ms-auto ml-2">
                <Button
                  style={{
                    background: "#17b77d",
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "5px",
                    borderRadius: "3px",
                    marginLeft: "12px",
                  }}
                  onClick={() => {
                    setUnassignedModal(true)
                    setUnassignLeadId(data.leadId)
                  }}
                >
                  <i className="fas fa-user-lock"></i>
                </Button>
              </div>
            </div>
          </>
        ),
        link: data.link ? data.link : "--",
        assignedHistory: data.assignedHistory,
        key: index,
        clearanceStatusName: data.ecClearanceStatusName,
        paymentStatus: paymentStatus,
        groomName: data.groomName ? data.groomName : "--",
        brideName: data.brideName ? data.brideName : "--",
        ecClearanceStatus: data.ecClearanceStatus,
        clearanceDetails: data,
        clearanceHistory: data.leadClearanceHistory
          ? data.leadClearanceHistory
          : "",
        operationalHistory: data.operationalHistory,
        cpStatus:
          data.clientProfileStatus && data.clientProfileStatus != null
            ? data.clientProfileStatus
            : "--",
        cpRemarks: data.clientProfileRemarks
          ? data.clientProfileRemarks
          : "--",
        assignedDate:
          !isEmpty(data.postCrmAssignedDate) ||
            (data.postCrmAssignedDate != null && data.postCrmAssignedDate)
            ? moment(data.postCrmAssignedDate).format(dateFormat)
            : "--",
        isMainEventName: data.isMainEventName,
        isMainEventDate: data.isMainEventDate
          ? moment(data.isMainEventDate).format(dateFormat)
          : "",
        eventName: eventNameValue,
        eventDate: eventDateValue,
        dataCopyStatus: data.dataCopyStatus ? data.dataCopyStatus : "",
        dataCopyColorCode: dataCopyColorCode,
        dataProcessStatus: data.dataProcessStatus ? data.dataProcessStatus : "",
        lastFollowupDate: data.lastFollowupDate ? moment(data.lastFollowupDate).format(dateFormat) : "--",
        nextFollowupDate: data.nextFollowupDate ? moment(data.nextFollowupDate).format(dateFormat) : "--",
        followupAging: data.followupAging ? data.followupAging : "--",
        openIssuesCount: data.openIssuesCount ? data.openIssuesCount : "--",
        issuesDepartment: data.issueDepartment ? data.issueDepartment : "--",
        ecAttachment: data.EC_Followups ? data.EC_Followups : [],
        salesAttachment: data.LeadCurrentFollowups
          ? data.LeadCurrentFollowups
          : [],
        pendingDeliverableCount: pendingDeliverableCountValue,
        salesAgent: data.SalesAgentName ? data.SalesAgentName : "--",
        eventVenue: eventVenue,
        copiedDate: data.copiedDate ? moment(data.copiedDate).format(dateFormat) : "--",
        clientType: data.leadQuotationRange,
        isEscalation: data.isOperationEscalation,
        onlyEngagement: data.onlyEngagement,
        closedFollowupCount: data.closedFollowupCount || 0,
        openFollowupCount: data.openFollowupCount || 0,
        goodLookingClient: data.goodLookingClient,
        highEndClient: data.highEndClient,
        onlyEngagementStatus: data.onlyEngagementStatus,
        photoCopyStatus: data.photoStatus,
        videoCopyStatus: data.videoStatus


      }
    })
    : []

  //assign history api call
  const assignHistory = (data) => {
    const historyPayload = {
      operationId: data.operationId,
      deliverableId: data.deliverableId,
      mode: "POST",
    }
    setHistoryModal(true)
    setTimeout(() => {
      dispatch(
        crmManageClientAction.loadProductionAssignHistory(historyPayload)
      )
    }, 500)
  }
  const historyUpdate = useSelector((state) => state.crmManageClient)

  const { history_details = [] } = historyUpdate

  useEffect(() => {
    if (crmAssignDetails.length > 0) {
      setCrmAssignButton(true)
      setUnAssignButton(true)
    } else {
      setCrmAssignButton(false)
      setUnAssignButton(false)
    }
  }, [crmAssignDetails])
  //main event radio
  const [selectedRowIndex, setSelectedRowIndex] = useState(null)
  const [selectedData, setSelectedData] = useState({})
  //event
  const loadEventData = (payload) => {
    setEventServiceModal(true)
    setSelectedRowIndex(null)
    setTimeout(() => {
      dispatch(crmManageClientAction.loadMainEvent(payload))
    }, 500)
  }
  const [mainLeadId, setMainLeadId] = useState("")
  const clientEventUpdate = useSelector(
    (specificstate) => specificstate.myWorksCompleted
  )
  const { clientEvent_data = [] } = clientEventUpdate

  const [clientEventModal, setClientEventModal] = useState(false)
  const loadClientEvent = (payload) => {
    setClientEventModal(true)
    setTimeout(() => {
      dispatch(eventClientAction.loadClientEvent(payload))
    })
  }
  const [escalationRemove, setEscalationRemove] = useState()
  const getCellStyleWithColor = (row) => {
    if (row.tatHistoryArray) {
      const length = row.tatHistoryArray.length

      if (length === 1) {
        return {} // No styles applied
      } else if (length === 2) {
        return { backgroundColor: "#5ced73", justifyContent: "center", textAlign: "center" } // Green
      } else if (length === 3) {
        return { backgroundColor: "#FCF55F", justifyContent: "center", textAlign: "center" } // Yellow
      } else if (length > 3) {
        return { backgroundColor: "#f78f8f", justifyContent: "center", textAlign: "center" } // Red
      }
    }

    return {}
  }
  const getCellStyle = (row) => {
    if (row.tatHistoryArray) {
      const length = row.tatHistoryArray.length

      if (length === 1) {
        return {}// No styles applied
      } else if (length === 2) {
        return { backgroundColor: "#5ced73" }// Green
      } else if (length === 3) {
        return { backgroundColor: "#FCF55F" }// Yellow
      } else if (length > 3) {
        return { backgroundColor: "#f78f8f" }// Red
      }
    }

    return {}
  }
  const getCellStyleWithText = (row) => {
    if (row.tatHistoryArray) {
      const length = row.tatHistoryArray.length

      if (length === 1) {
        return {} // No styles applied
      } else if (length === 2) {
        return { backgroundColor: "#5ced73", textTransform: "uppercase", color: "#e40d8c", } // Green
      } else if (length === 3) {
        return { backgroundColor: "#FCF55F", textTransform: "uppercase", color: "#e40d8c", } // Yellow
      } else if (length > 3) {
        return { backgroundColor: "#f78f8f", textTransform: "uppercase", color: "#e40d8c", } // Red
      }
    }
    return {}
  }
  //columns for data table
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      style: (cell, row) => getCellStyle(row),

    },
    {
      dataField: "leadNo",
      text: "Lead No",
      style: (cell, row) => getCellStyleWithText(row),

      formatter: (cellContent, row) => {
        const crmData = row.rowData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: crmData,
                  leadClientId: crmData,
                  mode: "Operations",
                },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </>
        )
      },
      headerStyle: {
        minWidth: "125px",
      },
      hidden: false,
    },
    {
      dataField: "isEscalation",
      text: "Is Escalation Client",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyleWithColor(row),

      formatter: (cellContent, row) => {

        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>
                {cellContent == true ? <Badge
                  color="danger"
                  style={{
                    display: "inline-block",
                    width: "35px",        // Equal width and height for a circle
                    height: "35px",
                    borderRadius: "50%",
                  }}
                /> : "--"}
              </div>
            </Col>
            <Col md="2" lg="2" sm="2">
              <Button
                style={{
                  border: "none",
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  setEscalationRemove(cellContent)
                  setIsEscalationModal(true)
                  setLeadId(row.leadId)
                }}
                className="btn btn-warning"

              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </Button>
            </Col>
          </Row>
        )


      },
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      style: (cell, row) => getCellStyleWithColor(row),

      formatter: (cellContent) => {

        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break

          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            badgeStyle = {}
        }


        return (
          <div style={{ textAlign: "center", justifyContent: "center" }}>
            {cellContent ? (
              <span
                className={"badge"}
                style={{
                  ...badgeStyle,
                  display: "inline-block",
                  width: "35px",        // Equal width and height for a circle
                  height: "35px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>--</span>
              // Show '--' if cellContent is empty
            )}
          </div>)

      }
    },//
    {
      dataField: "onlyEngagement",
      text: "Only Engagement",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyleWithColor(row),

      formatter: (cellContent, row) => {
        console.log(cellContent, row, "kk")
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#c5ff00",
                    backgroundColor: "#c5ff00"
                  }}
                /> : "--"}
              </div>
              {row.onlyEngagementStatus ? `(${row.onlyEngagementStatus})` : ""}
            </Col>

          </Row>
        )


      },

      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "goodLookingClient",
      text: "Good Looking Client",
      hidden: true,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#FFD700",
                    backgroundColor: "#BF55EC"
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => getCellStyleWithColor(row),

      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "highEndClient",
      text: "High End Client",
      hidden: true,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#BF55EC",
                    backgroundColor: "#FFD700"

                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => getCellStyleWithColor(row),

      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",

      style: (cell, row) => getCellStyleWithText(row),

      formatter: (cellContent, row) => {
        const payload = {
          clientNo: row.clientCode,
        }
        return (
          <div>
            {" "}
            <a onClick={() => loadClientEvent(payload)}>{cellContent}</a>
          </div>
        )
      },
      headerStyle: {
        minWidth: "130px",
      },
      hidden: false,
    },
    {
      dataField: "companyName",
      text: "Company",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),

      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),

      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),

      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),

      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "eventVenue",
      text: "Event Venue",
      headerStyle: {
        minWidth: "160px",
      },
      hidden: true,
      style: (cell, row) => getCellStyle(row),
    },
    {
      dataField: "crmAssign",
      text: "CRM Assign",
      headerStyle: {
        minWidth: "150px",
      },
      style: (cell, row) => getCellStyle(row),
      hidden: false,
    },

    {
      dataField: "clearanceStatus",
      text: "Clearance Status",
      formatter: (cellContent, row) => {
        const paymentStatus = row.paymentStatus

        let badgeClassName = ""
        if (paymentStatus === "paid") {
          badgeClassName = "bg-success"
        } else if (paymentStatus === "unpaid") {
          badgeClassName = "bg-danger"
        } else if (paymentStatus === "partialpaid") {
          badgeClassName = ""
        } else if (
          paymentStatus === "complementary" ||
          paymentStatus === "Complementary"
        ) {
          badgeClassName = ""
        } else if (
          paymentStatus === "Exception" ||
          paymentStatus === "exception"
        ) {
          badgeClassName = ""
        } else {
          badgeClassName = "bg-danger"
        }
        const badgeStyle =
          paymentStatus === "partialpaid"
            ? { backgroundColor: "#f9851b", padding: "5px" }
            : paymentStatus === "complementary" ||
              paymentStatus === "Complementary"
              ? { backgroundColor: "#50a5f1", padding: "5px" }
              : paymentStatus === "Exception" || paymentStatus === "exception"
                ? { backgroundColor: "#d63afd", padding: "5px" }
                : { padding: "5px" }
        return (
          <div className="d-flex flex-row align-items-center">
            {!isEmpty(row.clearanceStatusName) ? (
              <span
                className={`badge ${badgeClassName}`}
                style={badgeStyle}
                onClick={() => {
                  setClearanceModal(true)
                  setClearanceDetails(row.clearanceDetails)
                }}
              >
                {row.clearanceStatusName}
              </span>
            ) : (
              "--"
            )}
            <div
              className="ms-auto ml-2"
              onClick={() => {
                setClearanceHistoryDetails(row.clearanceHistory)
                setClearanceHistoryModal(true)
              }}
            >
              <i
                className="fas fa-eye"
                style={{ color: "#50a5f1", fontSize: "13px" }}
              ></i>
            </div>
          </div>
        )
      },
      headerStyle: {
        minWidth: "175px",
      },
      style: (cell, row) => getCellStyle(row),
      hidden: false,
    },
    {
      dataField: "dataCopyStatus",
      text: "Data Copy Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {

        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {!isEmpty(row.dataCopyStatus) ? (
                <button
                  style={{
                    background: row.dataCopyColorCode,
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                    padding: "2px",
                    borderRadius: "4px",
                  }}
                >
                  {row.dataCopyStatus}
                </button>
              ) : (
                "--"
              )}
            </Col>

          </Row>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "photoCopyStatus",
      text: "Photo Copy Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),

      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "videoCopyStatus",
      text: "Video Copy Status",
      hidden: false,
      editable: false,
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "copiedDate",
      text: "Copied Date",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: true,
    },
    {
      dataField: "openIssuesCount",
      text: "Open Issues Count",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },
    {
      dataField: "issuesDepartment",
      text: "Issue Departments",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },
    {
      dataField: "lastFollowupdate",
      text: "Last Followup Date",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },
    {
      dataField: "nextFollowupdate",
      text: "Next Followup Date",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },
    {
      dataField: "followupAging",
      text: "Followup Aging",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "160px",
      },
      hidden: false,
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "130px",
      },
      hidden: false,
    },

    {
      dataField: "clientName",
      text: "Client Name ",
      style: (cell, row) => getCellStyle(row),
      headerStyle: {
        minWidth: "135px",
      },
      hidden: true,
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      style: (cell, row) => getCellStyle(row),
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      style: (cell, row) => getCellStyle(row),
      hidden: true,
      headerStyle: {
        minWidth: "160px",
      },
    },


    {
      dataField: "leadDate",
      text: "Lead Date",
      headerStyle: {
        minWidth: "125px",
      },
      style: (cell, row) => getCellStyle(row),
      hidden: true,
    },
    {
      dataField: "openFollowupCount",
      text: "Open Followup Count",
      headerStyle: {
        minWidth: "215px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {cellContent}
            </span>
          </div>
        )
      },
      hidden: false,
    },
    {
      dataField: "closedFollowupCount",
      text: "Closed Followup Count",
      headerStyle: {
        minWidth: "215px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {cellContent}
            </span>
          </div>
        )
      },
      hidden: false,
    },
    {
      dataField: "pendingDeliverableCount",
      text: "Pending Deliverable Count",
      headerStyle: {
        minWidth: "215px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.pendingDeliverableCount}
            </span>
          </div>
        )
      },
      hidden: false,
    },

    {
      dataField: "deliverables",
      text: "No of Deliverables",
      headerStyle: {
        minWidth: "150px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.deliverables}
            </span>
          </div>
        )
      },
      hidden: false,
    },


    {
      dataField: "assignedDate",
      text: "Assigned Date",
      headerStyle: {
        minWidth: "160px",
      },
      style: (cell, row) => getCellStyle(row),
      hidden: false,
    },
    {
      dataField: "isMainEvent",
      text: "Is Main Event",
      headerStyle: {
        minWidth: "160px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        const payload = {
          leadId: row.leadId,
        }
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              {row.isMainEventName && row.isMainEventDate
                ? `${row.isMainEventName} - ${row.isMainEventDate}`
                : "--"}
            </Col>
            <Col md="2" lg="2" sm="2">
              <Button
                style={{
                  border: "none",
                  cursor: "pointer",
                  padding: "4px 8px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  loadEventData(payload)
                  setMainLeadId(row.leadId)
                }}
                className="btn btn-success"
                disabled={row.isMainEventName && row.isMainEventDate}
              >
                <i
                  className="fas fa-edit icon-btn"
                  style={{ fontSize: "10px" }}
                ></i>
              </Button>
            </Col>
          </Row>
        )
      },
      hidden: false,
    },
    {
      dataField: "salesAgent",
      text: "Sales Agent",
      headerStyle: {
        minWidth: "160px",
      },
      style: (cell, row) => getCellStyle(row),
      hidden: false,
    },
    {
      dataField: "dormantClient",
      text: "Dormant Client",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "130px",
      },
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {
        return (
          <Button
            style={{
              border: "none",
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "3px",
            }}
            onClick={() => {
              setDormantModal(true)
              setLeadId(row.leadId)
              setDormantData({
                remarks: "",
              })
            }}
            className="btn btn-success"
          >
            Update
          </Button>
        )
      },
    },
    {
      dataField: "ecAttachment",
      text: "EC Confirmation Call",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {

        const attachmentDetails = !isEmpty(row.ecAttachment) && row.ecAttachment.length > 0
          ? row.ecAttachment.filter((reason) => reason.followupReasonName == "Final Confirmation") : []
        const attachCount =
          !isEmpty(attachmentDetails) && attachmentDetails.length > 0
            ? attachmentDetails.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(attachmentDetails) ? (
                  <a
                    onClick={() => {
                      setEcAttachmentModal(true)
                      setEcAttachmentDetails(attachmentDetails)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },

      csvExport: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
    {
      dataField: "salesAttachment",
      text: "Sales Confirmation Call",
      editable: false,
      hidden: false,
      style: (cell, row) => getCellStyle(row),
      formatter: (cellContent, row) => {

        const attachmentDetails = !isEmpty(row.salesAttachment) && row.salesAttachment.length > 0
          ? row.salesAttachment.filter((reason) => reason.modeName == "SALES SERVICE CONFIRMATION CALL") : []
        const attachCount =
          !isEmpty(attachmentDetails) && attachmentDetails.length > 0
            ? attachmentDetails.length
            : 0
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              <div>
                {!isEmpty(attachmentDetails) ? (
                  <a
                    onClick={() => {
                      setSalesAttachmentModal(true)
                      setSalesAttachmentDetails(attachmentDetails)
                    }}
                  >
                    <span
                      style={{
                        textDecoration: "underline",
                        color: "#E40D8C",
                      }}
                    >
                      View
                    </span>
                  </a>
                ) : (
                  "--"
                )}
              </div>
            </Col>
            <Col md="4" lg="4" sm="4">
              <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {attachCount}
                </span>
              </div>
            </Col>
          </Row>
        )
      },
      csvExport: true,
      headerStyle: {
        minWidth: "185px",
      },
    },
  ]
  const updateEscalation = () => {
    const payload = {
      "leadId": leadId,
      "isOperationEscalation": escalationRemove == true ? false : true
    }
    console.log(payload)
    setIsEscalationModal(false)
    dispatch(crmManageClientAction.updateEscalation(payload))
    setTimeout(() => {
      dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      toast.success("IsEscalation Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })

    }, 1000)

  }


  //Data Table section
  const clientDataTable = !isEmpty(clientEvent_data)
    ? clientEvent_data.map((data, index) => {
      //////////////
      const eventName = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventName).join(",")
        : "--"
      const eventNo = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.eventNo).join(",")
        : "--"
      const eventDate = !isEmpty(data.eventDetails)
        ? data.eventDetails
          .map((m) => moment(m.eventDate).format(dateFormat))
          .join(",")
        : "--"
      const startTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.startTime).join(",")
        : "--"
      const endTime = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.endTime).join(",")
        : "--"
      const venue = !isEmpty(data.eventDetails)
        ? data.eventDetails.map((m) => m.venueLocation).join(",")
        : "--"
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadNo: data.leadNo,
        sNo: index + 1,
        serviceCount: !isEmpty(data.serviceDetails)
          ? data.serviceDetails.length
          : 0,
        isCommit: data.isCommit,
        eventName: eventName,
        eventNo: eventNo,
        eventDate: eventDate,
        startTime: startTime,
        endTime: endTime,
        venueLocation: venue,
        serviceDetails: data.serviceDetails,
      }
    })
    : []

  //table columns
  const clientColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      csvExport: false,
      hidden: false,
      formatter: (cellContent, row) => {
        return <span>{row.leadNo}</span>
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "serviceCount",
      text: "Services",
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.serviceCount}
            </span>
          </div>
        )
      },
    },
    {
      dataField: "isCommit",
      text: "Commit",
      headerStyle: {
        minWidth: "120px",
      },
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isCommit === true ? "success" : "danger"}
            style={{ padding: "6px", fontSize: "12px" }}
          >
            {row.isCommit === true ? "Yes" : "No"}
          </Badge>
        )
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]
  const clientExpandRow = {
    renderer: (row) => (
      <>
        <Table bordered responsive>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Team Shooter
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Freelancer Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Status
              </th>

              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                File Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Size
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Remarks
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              !isEmpty(row.serviceDetails) &&
              row.serviceDetails.length > 0 ? (
              row.serviceDetails.map((data, index) => {
                const serviceName = !isEmpty(data.serviceId)
                  ? data.serviceId.serviceName
                  : "--"
                const freelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceMainShooterName
                    )
                    : []

                const freelancerName =
                  !isEmpty(freelancer) && freelancer.length > 0
                    ? freelancer.join(",")
                    : "--"

                const subFreelancer =
                  !isEmpty(data) && data.teamFreelanceShooter.length > 0
                    ? data.teamFreelanceShooter.map(
                      (m) => m.freelanceSubShooterName
                    )
                    : []

                const subFreelancerName =
                  !isEmpty(subFreelancer) && subFreelancer.length > 0
                    ? subFreelancer.join(",")
                    : "--"

                const shooterName = !isEmpty(data.teamEmployeeShooterId)
                  ? data.teamEmployeeShooterId.empCode +
                  "-" +
                  data.teamEmployeeShooterId.name
                  : "--"
                return (
                  <tr key={index}>
                    <td>{data.serviceNo ? data.serviceNo : "--"}</td>
                    <td>{serviceName}</td>
                    <td>{shooterName}</td>
                    <td>{freelancerName}</td>
                    <td>{subFreelancerName}</td>
                    <td>
                      {data.serviceLevelStatusName
                        ? data.serviceLevelStatusName
                        : "--"}
                    </td>
                    {/* <td>{etaDate}</td> */}
                    <td>{data.fileCount ? data.fileCount : "--"}</td>
                    <td>{data.size ? data.size : "--"}</td>
                    <td>{data.remarks ? data.remarks : "--"}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={8}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),

    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  // pagination options
  const clientOptions = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }
  const handleRadioChange = (index, data) => {
    setSelectedRowIndex(index)
    // Perform any action you want here when a radio button is clicked
    setSelectedData({
      leadId: mainLeadId,
      leadEventId: data.leadEventId,
      IsMainEvent: true,
    })
  }
  const deliverDataTable = !isEmpty(mainEvent_data)
    ? mainEvent_data.map((data, index) => {
      return {
        index: index,
        key: index,
        leadId: data.leadId,
        leadEventId: data.leadEventId,
        sNo: index + 1,
        eventName: data.eventName ? data.eventName : "--",
        eventNo: data.eventNo ? data.eventNo : "--",
        eventDate: data.eventDate
          ? moment(data.eventDate).format(dateFormat)
          : "--",
        startTime: data.startTime ? data.startTime : "--",
        endTime: data.endTime ? data.endTime : "--",
        Toggle: (
          <div className="form-check form-check-inline">
            <Input
              type="radio"
              name={`MainEvent_${data.leadEventId}`}
              value="true"
              checked={selectedRowIndex === index}
              onChange={() => handleRadioChange(index, data)}
            />
          </div>
        ),
      }
    })
    : []

  //table columns
  const eventColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      editable: false,
    },

    {
      dataField: "eventName",
      text: "Event Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },

    {
      dataField: "eventNo",
      text: "Event No",
      editable: false,
      csvExport: false,
      headerStyle: {
        minWidth: "120px",
      },
    },

    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "startTime",
      text: "Start Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "Toggle",
      text: "Is Main Event",
      headerStyle: {
        minWidth: "130px",
      },
    },
  ]
  const updateMainEvent = () => {
    setEventServiceModal(false)
    if (selectedData.IsMainEvent == true) {
      dispatch(crmManageClientAction.updateMainEvent(selectedData))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
        toast.success("Is Main Event Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 500)
    }
  }
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  //Editable columns section start
  //columns local storage
  const saveColumnsToLocalStorage = (columns) => {
    localStorage.setItem('CrmColumn', JSON.stringify(columns))
  }
  const getColumnsFromLocalStorage = () => {
    const savedColumns = localStorage.getItem('CrmColumn')
    return savedColumns ? JSON.parse(savedColumns) : []
  }
  const storedColumns = getColumnsFromLocalStorage()
  const storedColumnWithFormatter = initialColumns.map((col) => {
    const storedCol = !isEmpty(storedColumns) && storedColumns.find((sc) => sc.dataField === col.dataField)
    return { ...col, ...storedCol }
  })

  //Editable columns section
  const [columns, setColumns] = useState(storedColumnWithFormatter || initialColumns)

  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    saveColumnsToLocalStorage(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }
  //Editable columns section end
  //expand row product and team assign
  const [productAssignDetails, setProductAssignDetails] = useState([])
  const [productSubmitButton, setProductSubmitButton] = useState(false)

  const [multiProductModal, setMultiProductModal] = useState(false)
  const [multiTeamModal, setMultiTeamModal] = useState(false)

  const [teamAssignDetails, setTeamAssignDetails] = useState([])
  const [teamSubmitButton, setTeamSubmitButton] = useState(false)

  const [multiProductEmployee, setMultiProductEmployee] = useState([])
  const [multiTeamEmployee, setMultiTeamEmployee] = useState([])

  const [multiProductData, setMultiProductData] = useState({
    note: "",
  })
  const handleMultiProduct = (e) => {
    setMultiProductData({
      ...multiProductData,
      [e.target.name]: e.target.value,
    })
  }
  const [multiTeamData, setMultiTeamData] = useState({
    note: "",
  })
  const handleMultiTeam = (e) => {
    setMultiTeamData({ ...multiTeamData, [e.target.name]: e.target.value })
  }
  const [multiProductFile, setMultiProductFile] = useState([])
  const [productFileName, setProductFileName] = useState("")
  const [productFileLength, setProductFileLength] = useState("")

  const multiProductChange = async (e) => {
    if (e.target.files) {
      setMultiProductFile(e.target.files)
      var file = e.target.files
      setProductFileName(file[0].name)
      setProductFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiProductFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiProductFile(teamUploadValue)
          }
        })
      }
    }
  }
  const [multiTeamFile, setMultiTeamFile] = useState([])
  const [teamFileName, setTeamFileName] = useState("")
  const [teamFileLength, setTeamFileLength] = useState("")
  const multiTeamChange = async (e) => {
    if (e.target.files) {
      setMultiTeamFile(e.target.files)
      var file = e.target.files
      setTeamFileName(file[0].name)
      setTeamFileLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = multiTeamFile

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setMultiTeamFile(teamUploadValue)
          }
        })
      }
    }
  }
  const addUnAssign = () => {
    const unAssign_data = {
      leadId: [unAssignLeadId],
    }
    dispatch(crmManageClientAction.addUnassign(unAssign_data))
    dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
  }

  const multiUnAssignLeadId =
    !isEmpty(crmAssignDetails) && crmAssignDetails.length > 0
      ? crmAssignDetails.map((m) => m.leadId)
      : []
  const addMultiUnAssign = () => {
    const unAssign_data = {
      leadId: multiUnAssignLeadId,
    }
    dispatch(crmManageClientAction.addUnassign(unAssign_data))
    dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
    setTimeout(() => {
      setCrmAssignDetails([])
    }, 500)
  }
  const handleClearAssignModal = () => {
    setMultiProductEmployee([])
    setMultiTeamEmployee([])
    setMultiProductData({ ...multiProductData, note: "" })
    setMultiTeamData({ ...multiTeamData, note: "" })
    setMultiProductFile([])
    setMultiTeamFile([])
    setProductFileLength("")
    setProductFileName("")
    setTeamFileLength("")
    setTeamFileName("")
  }

  const [expanded, setExpanded] = useState([])
  // const [dataModal, setDataModal] = useState(false)
  //const [dataOperationId, setDataOperationId] = useState("")
  // const updateData = () => {
  //   const dataDetails = {
  //     operationId: dataOperationId,
  //     isDataStatus: true,
  //   }
  //   specificDispatch(crmManageClientAction.updateData(dataDetails))
  //   setTimeout(() => {
  //     toast.success("Data Details Updated Successfully!", {
  //       position: toast.POSITION.TOP_RIGHT,
  //       autoClose: 1000,
  //     })
  //     specificDispatch(crmManageClientAction.loadCrmManageClient(searchValue))
  //   }, 500)
  // }

  // const [updateLeadId]
  const expandRow = {
    renderer: (row) => (
      <>
        <Table>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Product Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Deliverable Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Print Status
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Product Lead Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                End Worker Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                CRM Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                ETA Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Quantity
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Print Deliverable Code
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sheet/Count
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Deliverables
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Assigned History
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Sub Status
              </th>
            </tr>
          </thead>
          <tbody>
            {row &&
              row.deliverableDetails &&
              row.deliverableDetails.length > 0 ? (
              row.deliverableDetails.map((data) => {
                const sheet =
                  isEmpty(data.sheetLength) && data.sheetLength == null
                    ? 0
                    : data.sheetLength
                const eventDate = !isEmpty(data.eventDate)
                  ? moment(data.eventDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(dateFormat)
                  : "--"
                const eventDateValue =
                  eventDate === "Invalid date" ? "--" : eventDate

                const teamLeadName = !isEmpty(data.assignedTeamlead)
                  ? data.assignedTeamlead
                    .map((employee) => employee.employeeCode + "-" + employee.employeeName)
                    .join(", ")
                  : ""

                const employeeName = !isEmpty(data.assignedEmployee)
                  ? data.assignedEmployee
                    .map((employee) => employee.employeeCode + "-" + employee.employeeName)
                    .join(", ")
                  : ""
                const crmName = !isEmpty(data.assignedCrmEmployee)
                  ? data.assignedCrmEmployee
                    .map((employee) => employee.employeeCode + "-" + employee.employeeName)
                    .join(", ")
                  : ""


                const tat = data.tat ? moment(data.tat) : ""
                const etaDate = tat
                  ? tat.add(etaValue, "days").format(dateFormat)
                  : "--"
                // const assignDatas = row.rowData
                const colorCode =
                  !isEmpty(recordsMetaData) &&
                  recordsMetaData.processStatusOptions &&
                  recordsMetaData.processStatusOptions.length > 0 &&
                  recordsMetaData.processStatusOptions.find(
                    (_) => _.processStatusId === data.productionprocessstatus
                  ) &&
                  recordsMetaData.processStatusOptions.find(
                    (_) => _.processStatusId === data.productionprocessstatus
                  )?.colorCode
                const arrayLength = data?.tatHistory?.length || 0

                const getTdStyle = () => {
                  if (arrayLength === 1) return {} // No styles applied
                  if (arrayLength === 2) return { background: "#5ced73" } // Green
                  if (arrayLength === 3) return { background: "#FCF55F" } // Yellow
                  if (arrayLength > 3) return { background: "#f78f8f" } // Red
                  return {} // Default case
                }

                const tdStyle = getTdStyle()

                return (
                  <tr key={data._id}>
                    <th scope="data" style={tdStyle}>{data.productName}</th>
                    <td style={tdStyle}>{data.eventName}</td>
                    <td style={tdStyle}>{eventDateValue}</td>
                    <td style={tdStyle}>
                      <Row>
                        <Col md="8" lg="8" sm="8">
                          {data.productioProcessStatusName ? (
                            <button
                              style={{
                                background: colorCode,
                                border: "none",
                                cursor: "pointer",
                                color: "white",
                                padding: "2px",
                                borderRadius: "4px",
                              }}
                            >
                              {data.productioProcessStatusName}
                            </button>
                          ) : (
                            "--"
                          )}
                        </Col>
                        <Col md="2" lg="2" sm="2">
                          <button
                            style={{
                              background: "#17b77d",
                              border: "none",
                              cursor: "pointer",
                              color: "white",
                              padding: "4px 8px",
                              borderRadius: "3px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation()
                              setUpdateProcess(data)
                              setProcessStatusModal(true)
                              handleClearModal()
                              setProcessHistoryDetails(data.processHistory)
                              setLeadId(row._id)
                              setPrintable(data.isPrintable)
                              clearPrintPlData()
                              setPrintableData(row)
                            }}
                          >
                            <i
                              className="fas fa-edit icon-btn"
                              style={{ fontSize: "10px" }}
                            ></i>
                          </button>
                        </Col>
                      </Row>
                    </td>
                    <td style={tdStyle}>{data.printProcessStatusName ?
                      data.printProcessStatusName : "--"}</td>
                    <td style={tdStyle}>
                      {" "}
                      <div className="d-flex flex-row align-items-center">
                        {teamLeadName ? teamLeadName : "--"}
                        {
                          !isEmpty(crmName) ?
                            <div className="ms-auto ml-2">
                              <Input
                                type="checkbox"
                                checked={productAssignDetails.some(
                                  (item) => item._id === data._id
                                )}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginLeft: "10px",
                                }}
                                // onChange={(e) => {
                                //   if (paymentStatus === "paid" && ((dataProcessStatus != "PS71" || dataProcessStatusName != "DATA COPY PENDING") && dataProcessStatus!="" || dataProcessStatusName !="")) {
                                //     if (
                                //       e.target.checked &&
                                //       !productAssignDetails.find((item) => item._id === data._id) &&
                                //       isEmpty(teamAssignDetails)
                                //     ) {
                                //       setProductAssignDetails([
                                //         ...productAssignDetails,
                                //         data,
                                //       ])
                                //     } else {
                                //       setProductAssignDetails(
                                //         productAssignDetails.filter(
                                //           (item) => item._id !== data._id
                                //         )
                                //       )
                                //     }
                                //     const anyChecked = productAssignDetails.some(
                                //       (item) => item._id !== data._id
                                //     )
                                //     setLeadId(row._id)
                                //     setProductSubmitButton(anyChecked)
                                //   } else {

                                //     if (
                                //       paymentStatus !== "paid" && 
                                //       (dataProcessStatus === "PS71" || dataProcessStatusName === "DATA COPY PENDING" || !dataProcessStatus || !dataProcessStatusName)
                                //     ) {
                                //       setCommonAlertModal(true)
                                //     } else if (
                                //       (dataProcessStatus === "PS71" || dataProcessStatusName === "DATA COPY PENDING" || !dataProcessStatus || !dataProcessStatusName) &&
                                //       paymentStatus === "paid"
                                //     ) {
                                //       setCopyAlertModal(true)
                                //     } else if (
                                //       paymentStatus !== "paid" && 
                                //       (dataProcessStatus !== "PS71" || dataProcessStatusName !== "DATA COPY PENDING")
                                //     ) {
                                //       setAlertModal(true)
                                //     } else {
                                //       setCommonAlertModal(true)
                                //     }
                                //     e.target.checked = false
                                //   }
                                // }}
                                onChange={(e) => {

                                  if (
                                    e.target.checked &&
                                    !productAssignDetails.find((item) => item._id === data._id) &&
                                    isEmpty(teamAssignDetails)
                                  ) {
                                    setProductAssignDetails([
                                      ...productAssignDetails,
                                      data,
                                    ])
                                  } else {
                                    setProductAssignDetails(
                                      productAssignDetails.filter(
                                        (item) => item._id !== data._id
                                      )
                                    )
                                  }
                                  const anyChecked = productAssignDetails.some(
                                    (item) => item._id !== data._id
                                  )
                                  setLeadId(row._id)
                                  setProductSubmitButton(anyChecked)
                                }
                                }
                              />
                            </div> : ""
                        }
                      </div>{" "}
                    </td>
                    <td style={tdStyle}>
                      <div className="d-flex flex-row align-items-center">
                        {employeeName ? employeeName : "--"}
                        {
                          !isEmpty(teamLeadName) && !isEmpty(crmName) ?
                            <div className="ms-auto ml-2">
                              <Input
                                type="checkbox"
                                checked={teamAssignDetails.some(
                                  (item) => item._id === data._id
                                )}
                                style={{
                                  width: "15px",
                                  height: "15px",
                                  marginLeft: "10px",
                                }}
                                onChange={(e) => {
                                  e.stopPropagation()
                                  if (
                                    e.target.checked &&
                                    !teamAssignDetails.find(
                                      (item) => item._id === data._id
                                    ) &&
                                    isEmpty(productAssignDetails)
                                  ) {
                                    setTeamAssignDetails([
                                      ...teamAssignDetails,
                                      data,
                                    ])
                                  } else {
                                    setTeamAssignDetails(
                                      teamAssignDetails.filter(
                                        (item) => item._id !== data._id
                                      )
                                    )
                                  }
                                  const anyChecked = teamAssignDetails.some(
                                    (item) => item._id !== data._id
                                  )
                                  setLeadId(row._id)
                                  setTeamSubmitButton(anyChecked)
                                }}
                              />
                            </div> : ""
                        }
                      </div>
                    </td>
                    <td style={tdStyle}>
                      {" "}
                      <div className="d-flex flex-row align-items-center">
                        {crmName ? crmName : "--"}
                        {isEmpty(crmName) ? (
                          <div className="ms-auto ml-2">
                            <Input
                              type="checkbox"
                              checked={expandCrmDetails.some(
                                (item) => item._id === data._id
                              )}
                              style={{
                                width: "15px",
                                height: "15px",
                                marginLeft: "10px",
                              }}
                              onChange={(e) => {
                                if (
                                  e.target.checked &&
                                  !expandCrmDetails.find(
                                    (item) => item._id === data._id
                                  )
                                ) {
                                  setExpandCrmDetails([
                                    ...expandCrmDetails,
                                    data,
                                  ])
                                } else {
                                  setExpandCrmDetails(
                                    expandCrmDetails.filter(
                                      (item) => item._id !== data._id
                                    )
                                  )
                                }
                                const anyChecked = expandCrmDetails.some(
                                  (item) => item._id !== data._id
                                )
                                setLeadId(row._id)
                                setExpandCrmButton(anyChecked)
                              }}
                            />
                          </div>
                        ) : (
                          ""
                        )}
                      </div>{" "}
                    </td>
                    <td style={tdStyle}>{etaDate}</td>
                    <td style={tdStyle}>{data.quantity}</td>
                    <td style={tdStyle}>{data.printDeliverableCode ? data.printDeliverableCode : "--"}</td>
                    <td style={tdStyle}>{sheet + "/" + data.count}</td>
                    <td style={tdStyle}>
                      <div>
                        <Button
                          className="btn btn-info"
                          onClick={() => {
                            setDeliverablesData(data.operationalHistory)
                            setDeliverablesModal(true)
                          }}
                        >
                          Deliverables
                        </Button>
                      </div>
                    </td>
                    <td style={tdStyle}>
                      <div>
                        <a
                          onClick={() => {
                            assignHistory(data)
                          }}
                        >
                          <span
                            style={{
                              textDecoration: "underline",
                              color: "#E40D8C",
                            }}
                          >
                            History
                          </span>
                        </a>
                      </div>
                    </td>
                    <td style={tdStyle}>{data.subStatus ? data.subStatus : "--"}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={12}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    expanded,
    onExpand: (row, isExpand) => {
      if (isExpand) {
        //setExpanded([...expanded, row._id])
        setExpanded([row._id])
      } else {
        // setExpanded(expanded.filter((id) => id !== row._id))
        setExpanded([])
      }
    },
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }
  const plEmployeeValue = !isEmpty(plEmployee) ? plEmployee.map(m => m.value) : []
  const printSubmit = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const print_details = {
        notes: processData.notes,
        attachments: operationAttachment,
        employeeId: plEmployeeValue,
        printPlAssignDetail: [
          {
            leadId: leadId,
            operationId: updateProcess.operationId,
          },
        ],
        noOfSheet: printPlData.noOfSheets,
        noOfWrapperSheet: printPlData.noOfWrapperSheets,
        printFileLink: printPlData.printFileLink,
        additionalProductRemarks: printPlData.additionalProductRemarks,
        packageInclusionNumber: printPlData.packageInclusionNumber,
        packageInclusionRemarks: printPlData.packegeInclusionRemarks,
        deliveryAddress: printPlData.deliveryAddress,
        companyName: printableData.companyName,
        clientProfileStatus: printableData.cpStatus,
        eventName: updateProcess.eventName,
        productCategory: updateProcess.productCategory,
      }
      dispatch(crmManageClientAction.assignPrintPl(print_details))

      const submitStatus = {
        operationId: updateProcess.operationId,
        mode: "CRM",
        productionprocessstatus: operationStatus.value,
        notes: processData.notes,
        attachment: operationAttachment,
      }
      dispatch(crmManageClientAction.updateProcess(submitStatus))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
        setProcessStatusModal(false)
        toast.success("Process Status Updated successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
      }, 1000)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setProcessStatusModal(true)
    }
  }
  const processSubmit = (e) => {
    e.preventDefault()
    const submitStatus = {
      operationId: updateProcess.operationId,
      mode: "CRM",
      productionprocessstatus: operationStatus.value,
      notes: processData.notes,
      attachment: operationAttachment,
    }
    dispatch(crmManageClientAction.updateProcess(submitStatus))
    setTimeout(() => {
      dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      setProcessStatusModal(false)
      toast.success("Process Status Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }

  useEffect(() => {
    if (productAssignDetails.length > 0) {
      setProductSubmitButton(true)
    } else {
      setProductSubmitButton(false)
    }
  }, [productAssignDetails])
  useEffect(() => {
    if (teamAssignDetails.length > 0) {
      setTeamSubmitButton(true)
    } else {
      setTeamSubmitButton(false)
    }
  }, [teamAssignDetails])
  useEffect(() => {
    if (expandCrmDetails.length > 0) {
      setExpandCrmButton(true)
    } else {
      setExpandCrmButton(false)
    }
  }, [expandCrmDetails])
  //product submit
  const multipleProductEmployee =
    multiProductEmployee && multiProductEmployee.map((m) => m.value)

  const multiProductSubmit = () => {
    if (simpleProductValidator.current.allValid()) {
      const product_details = {
        menuMode: 3,
        employeeId: multipleProductEmployee,
        notes: multiProductData.note,
        attachments: multiProductFile,
        leadAssignDetail: productAssignDetails.map((data) => {
          return {
            leadId: leadId,
            leadDelivarableId: data.deliverableId,
            leadEventId: data.eventId,
          }
        }),
      }
      dispatch(crmManageClientAction.addProductAssign(product_details))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))

        setProductAssignDetails([])
        toast.success("Multiple Product Assigned successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setMultiProductModal(false)
      }, 1000)
    } else {
      simpleProductValidator.current.showMessages()
      forceUpdate(1)
      setMultiProductModal(true)
    }

  }
  //multi team assign
  const teamMultipleEmployee =
    multiTeamEmployee && multiTeamEmployee.map((m) => m.value)

  const teamMultipleSubmit = () => {
    if (simpleEwValidator.current.allValid()) {
      const team_details = {
        menuMode: 3,
        employeeId: teamMultipleEmployee,
        notes: multiTeamData.note,
        assignedBy: empId,
        attachments: multiTeamFile,
        leadAssignDetail: teamAssignDetails.map((data) => {
          return {
            leadId: leadId,
            leadDelivarableId: data.deliverableId,
            leadEventId: data.eventId,
          }
        }),
      }

      dispatch(crmManageClientAction.addTeamAssign(team_details))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
        setTeamAssignDetails([])
        toast.success("Team Lead Assigned successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        setMultiTeamModal(false)
      }, 1000)
    }
    else {
      simpleEwValidator.current.showMessages()
      forceUpdate(1)
      setMultiTeamModal(true)
    }
  }


  const [loading, setLoading] = useState(false)

  //Search filter

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      crmManageClientAction.loadCrmManageClient({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
        isOperationStatus: true,
      })
    )

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  let sNo = 0
  const exportToCsv = () => {
    var searchDataCopy = dataCopyStatus && dataCopyStatus ? dataCopyStatus.value : ""
    var searchEvent = events && events ? events.value : ""
    var searchFromDate =
      crmManageClientData && crmManageClientData.fromDate
        ? moment(crmManageClientData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      crmManageClientData && crmManageClientData.toDate
        ? moment(crmManageClientData.toDate).format("YYYY-MM-DD")
        : ""
    var searchEmp = agent && agent.value
    var searchAssignedFromDate =
      crmManageClientData && crmManageClientData.assignedFromDate
        ? moment(crmManageClientData.assignedFromDate).format("YYYY-MM-DD")
        : ""
    var searchAssignedToDate =
      crmManageClientData && crmManageClientData.assignedToDate
        ? moment(crmManageClientData.assignedToDate).format("YYYY-MM-DD")
        : ""
    var searchClientCode = crmManageClientData.clientCode
      ? crmManageClientData.clientCode
      : ""
    var searchGroom =
      crmManageClientData && crmManageClientData.groomName
        ? crmManageClientData.groomName
        : ""
    var searchBride =
      crmManageClientData && crmManageClientData.brideName
        ? crmManageClientData.brideName
        : ""
    var searchProductName = !isEmpty(products) ? products.value : ""
    var searchDeliverable = deliverableStatus && deliverableStatus.value
    var searchClearance =
      !isEmpty(clearanceStatus) && clearanceStatus.value
    var searchEwName = !isEmpty(ewName) ? ewName.value : ""
    var searchInProgress = inProgress === true ? "INPROGRESS" : ""
    var searchEngage = onlyEngagement == true ? true : ""
    var searchOpenFollowup =
      crmManageClientData && crmManageClientData.openFollowupCount !== undefined
        ? crmManageClientData.openFollowupCount === "0"
          ? 0
          : parseInt(crmManageClientData.openFollowupCount) || ""
        : ""
    var searchOperators = !isEmpty(openOperators) ? openOperators.value : ""
    var searchClientType = !isEmpty(clientType) ? clientType.value : ""
    var searchvalue = {}
    if (searchClientType) {
      searchvalue.clientType = searchClientType
    }

    searchvalue.isOperationStatus = true
    if (searchDataCopy) {
      searchvalue.dataCopyStatus = searchDataCopy
    }
    if (searchEvent) {
      searchvalue.eventNameId = searchEvent
    }
    if (searchEwName) {
      searchvalue.EWId = searchEwName
    }
    if (searchFromDate) {
      searchvalue.eventStartDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventEndDate = searchToDate
    }
    if (searchEmp) {
      searchvalue.empId = searchEmp
    }
    if (searchAssignedFromDate) {
      searchvalue.assignedFromDate = searchAssignedFromDate
    }
    if (searchAssignedToDate) {
      searchvalue.assignedToDate = searchAssignedToDate
    }

    if (searchGroom) {
      searchvalue.groomName = searchGroom
    }
    if (searchBride) {
      searchvalue.brideName = searchBride
    }
    if (searchProductName) {
      searchvalue.productCategoryId = searchProductName
    }
    if (searchDeliverable) {
      searchvalue.productionprocessstatus = searchDeliverable
    }
    if (searchClientCode) {
      searchvalue.clientCode = searchClientCode
    }
    if (searchClearance) {
      searchvalue.paymentType = searchClearance
    }
    if (searchInProgress) {
      searchvalue.subStatus = searchInProgress
    }
    if (searchEngage) {
      searchvalue.onlyEngagement = searchEngage
    }
    if (searchOpenFollowup !== "" && searchOpenFollowup !== undefined && searchOpenFollowup !== null) {
      searchvalue.openFollowupCount = searchOpenFollowup
    }
    if (searchOperators) {
      searchvalue.openOperators = searchOperators
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_crm_product_details_xcel_export_new`, searchvalue)
      .then((response) => {
        // const postExportInitialArray =
        //   !isEmpty(response) && response.data && response.data.data.length > 0
        //     ? response.data.data
        //     : []
        // const sortingExportTable = [...postExportInitialArray]

        // const sortedExportData = sortingExportTable.sort((a, b) => {
        //   const dateA = new Date(a.postCrmAssignedDate)
        //   const dateB = new Date(b.postCrmAssignedDate)
        //   return sortDirection === "asc" ? dateA - dateB : dateB - dateA
        // })

        const photoExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data) => {
            sNo = sNo + 1
            const eventCount =
              !isEmpty(data) && data.deliverableDetails.length > 0
                ? data.deliverableDetails.length
                : 0
            const deliverableCount =
              !isEmpty(data) && data.deliverableDetails.length > 0
                ? data.deliverableDetails.length
                : 0
            const overAllStatusList = !isEmpty(data.deliverableDetails)
              ? data.deliverableDetails.map((m) => m.overAllStatus).join(",")
              : "--"
            const overAllStatus = JSON.stringify(overAllStatusList).replace(
              /","/g,
              "\n"
            )
            const cpRemarks = !isEmpty(data.clientProfileRemarks)
              ? data.clientProfileRemarks.replace(/[\r\n,.]/gm, "")
              : "--"
            const dataDetails = !isEmpty(data.dataDetail)
              ? data.dataDetail[data.dataDetail.length - 1].isDataStatus
              : ""
            const dataValue =
              !isEmpty(dataDetails) && dataDetails == true
                ? "YES"
                : !isEmpty(dataDetails) && dataDetails == false
                  ? "NO"
                  : "--"
            const eventName = !isEmpty(data.eventName)
              ? data.eventName.map((m) => m).join(",")
              : ""
            const eventNameValue = !isEmpty(eventName)
              ? JSON.stringify(eventName).replace(/","/g, "\n")
              : "--"
            const eventVenue = !isEmpty(data.eventVenueName)
              ? data.eventVenueName.map((m) => m).join(",")
              : "--"
            const eventVenueValue = !isEmpty(eventVenue)
              ? JSON.stringify(eventVenue).replace(/","/g, "\n")
              : "--"
            const eventDate = !isEmpty(data.eventDate)
              ? data.eventDate
                .map((m) => moment(m).format(dateFormat))
                .join(",")
              : ""
            const eventDateValue = !isEmpty(eventDate)
              ? JSON.stringify(eventDate).replace(/","/g, "\n")
              : "--"
            const pendingDeliverableCount = data && data.deliverableDetails.length > 0 ?
              data.deliverableDetails.filter((status) => status.productionprocessstatus != "PS69" && status.productionprocessstatus != "PS46") : []

            const pendingDeliverableCountValue = !isEmpty(pendingDeliverableCount) ? pendingDeliverableCount.length : 0
            return {
              _id: data.leadId,
              sNo: sNo,
              leadNo: data.leadNo,
              company: data.companyName ? data.companyName : "--",
              branch: data.branchName ? data.branchName : "--",
              clientName: data.clientName ? data.clientName : "--",
              clientCode: data.clientCode ? data.clientCode : "--",
              groomName: data.groomName ? data.groomName : "--",
              brideName: data.brideName ? data.brideName : "--",
              events: eventCount,
              leadDate: data.leadDate
                ? moment(data.leadDate).format(dateFormat)
                : "--",
              deliverables: deliverableCount,
              overallStatus: overAllStatus ? overAllStatus : "--",
              crmAssign: data.postCrmAssignedName
                ? data.postCrmAssignedName
                : "--",
              clearanceStatus: data.ecClearanceStatusName
                ? data.ecClearanceStatusName
                : "--",
              cpStatus:
                data.clientProfileStatus && data.clientProfileStatus != null
                  ? data.clientProfileStatus
                  : "--",
              cpRemarks: cpRemarks,
              dataValue: dataValue,
              assignedDate:
                !isEmpty(data.postCrmAssignedDate) ||
                  data.postCrmAssignedDate != null
                  ? moment(data.postCrmAssignedDate).format(dateFormat)
                  : "--",
              eventName: eventNameValue,
              eventDate: eventDateValue,
              dataCopyStatus: data.dataCopyStatus ? data.dataCopyStatus : "",
              pendingDeliverableCount: pendingDeliverableCountValue,
              salesAgent: data.SalesAgentName ? data.SalesAgentName : "--",
              eventVenue: eventVenueValue,
              copiedDate: data.copiedDate ? moment(data.copiedDate).format(dateFormat) : "--",
              clientType: data.leadQuotationRange,
              isEscalation: data.isOperationEscalation == true ? "YES" : "NO",
              onlyEngagement: data.onlyEngagement == true ? "YES" : "NO",
              closedFollowupCount: data.closedFollowupCount || 0,
              openFollowupCount: data.openFollowupCount || 0,
              goodLookingClient: data.goodLookingClient == true ? "YES" : "NO",
              highEndClient: data.highEndClient == true ? "YES" : "NO",
              photoCopyStatus: data.photoStatus,
              videoCopyStatus: data.videoStatus
            }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Lead No,Is Escalation Client,Client Type,Only Engagement,Good Looking Client,High End Client,Client Code,Company,Bride Name,Groom Name,Event Date,Event Name,Event Venue,Crm Assign,Clearance Status,Data Copy Status,Photo Copy Status,Video Copy Status,Copied Date,Open Issues Count,Issue Department,Last Followup Date, Next Followup Date,Followup Aging,Branch Name,Client Name,CP Remarks,CP Status,Lead Date,Open Followup Count, Closed Followup Count,Pending Deliverable Count,No Of Deliverables,Assigned Date,Is Main Event,Sales Agent",
          ]

          let usersCsv =
            !isEmpty(photoExportDataTable) &&
            photoExportDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                isEscalation,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                clientCode,
                company,
                brideName,
                groomName,
                eventDate,
                eventName,
                eventVenue,
                crmAssign,
                clearanceStatus,
                dataCopyStatus,
                photoCopyStatus,
                videoCopyStatus,
                copiedDate,
                openIssuesCount,
                issueDepartment,
                lastFollowupDate,
                nextFollowupDate,
                followupAging,
                branch,
                clientName,
                cpRemarks,
                cpStatus,
                leadDate,
                openFollowupCount,
                closedFollowupCount,
                pendingDeliverableCount,
                deliverables,
                assignedDate,
                isMainEvent,
                salesAgent
              } = user
              acc.push([
                sNo,
                leadNo,
                isEscalation,
                clientType,
                onlyEngagement,
                goodLookingClient,
                highEndClient,
                clientCode,
                company,
                brideName,
                groomName,
                eventDate,
                eventName,
                eventVenue,
                crmAssign,
                clearanceStatus,
                dataCopyStatus,
                photoCopyStatus,
                videoCopyStatus,
                copiedDate,
                openIssuesCount,
                issueDepartment,
                lastFollowupDate,
                nextFollowupDate,
                followupAging,
                branch,
                clientName,
                cpRemarks,
                cpStatus,
                leadDate,
                openFollowupCount,
                closedFollowupCount,
                pendingDeliverableCount,
                deliverables,
                assignedDate,
                isMainEvent,
                salesAgent
              ])

              return acc
            }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "CrmManageClient.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          {teamSubmitButton ? (
                            <Button
                              className="btn btn-success text-nowrap"
                              onClick={() => {
                                setMultiTeamModal(true)

                                handleClearAssignModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              End Worker Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          {productSubmitButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiProductModal(true)
                                handleClearAssignModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              Product Lead Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          {unAssignButton ? (
                            <Button
                              className="btn btn-danger text-nowrap"
                              onClick={() => {
                                setMultiUnAssignModal(true)
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              CRM Unassign
                            </Button>
                          ) : (
                            ""
                          )}
                          {crmAssignButton ? (
                            <Button
                              className="btn btn-success text-nowrap"
                              onClick={() => {
                                setMultiCrmModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              CRM Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          {expandCrmButton ? (
                            <Button
                              className="btn btn-success text-nowrap"
                              onClick={() => {
                                setCrmExpandModal(true)
                                handleClearModal()
                              }}
                              style={{
                                marginRight: "10px",
                              }}
                            >
                              CRM Assign
                            </Button>
                          ) : (
                            ""
                          )}
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          noDataIndication={"No Data Found..."}
                          expandRow={expandRow}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: crmManageClient_details.length,
    data:
      !isEmpty(crmManageClient_details) && crmManageClient_details.length > 0
        ? crmManageClient_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(crmManageClient_details) && crmManageClient_details.length > 0
        ? crmManageClient_details
        : []
    if (
      !isEmpty(crmManageClientData.leadNo) ||
      !isEmpty(crmManageClientData.clientCode) ||
      !isEmpty(events) ||
      !isEmpty(crmManageClientData.fromDate) ||
      !isEmpty(crmManageClientData.toDate) ||
      !isEmpty(crmManageClientData.assignedFromDate) ||
      !isEmpty(crmManageClientData.assignedToDate) ||
      !isEmpty(agent) ||
      !isEmpty(products) ||
      !isEmpty(deliverableStatus) ||
      !isEmpty(ewName) ||
      !isEmpty(clearanceStatus) ||
      !isEmpty(inProgress) ||
      !isEmpty(dataCopyStatus) ||
      !isEmpty(openOperators) ||
      !isEmpty(crmManageClientData.openFollowupCount) ||
      !isEmpty(clientType)
    ) {
      var searchDataCopy = dataCopyStatus && dataCopyStatus ? dataCopyStatus.value : ""
      var searchEvent = events && events ? events.value : ""
      var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

      var searchFromDate =
        crmManageClientData && crmManageClientData.fromDate
          ? moment(crmManageClientData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        crmManageClientData && crmManageClientData.toDate
          ? moment(crmManageClientData.toDate).format("YYYY-MM-DD")
          : ""
      var searchOpenFollowup =
        crmManageClientData && crmManageClientData.openFollowupCount !== undefined
          ? crmManageClientData.openFollowupCount === "0"
            ? 0
            : parseInt(crmManageClientData.openFollowupCount) || ""
          : ""
      var searchOperators = !isEmpty(openOperators) ? openOperators.value : ""
      var searchEwName = !isEmpty(ewName) ? ewName.value : ""
      var searchEmp = agent && agent.value
      var searchInProgress = inProgress === true ? "INPROGRESS" : ""
      var searchEngage = onlyEngagement == true ? true : ""
      var searchAssignedFromDate =
        crmManageClientData && crmManageClientData.assignedFromDate
          ? moment(crmManageClientData.assignedFromDate).format("YYYY-MM-DD")
          : ""
      var searchAssignedToDate =
        crmManageClientData && crmManageClientData.assignedToDate
          ? moment(crmManageClientData.assignedToDate).format("YYYY-MM-DD")
          : ""
      var searchClientCode = crmManageClientData.clientCode
        ? crmManageClientData.clientCode
        : ""
      var searchGroom =
        crmManageClientData && crmManageClientData.groomName
          ? crmManageClientData.groomName
          : ""
      var searchBride =
        crmManageClientData && crmManageClientData.brideName
          ? crmManageClientData.brideName
          : ""
      var searchProductName = !isEmpty(products) ? products.value : ""
      var searchDeliverable =
        !isEmpty(deliverableStatus) && deliverableStatus.value
      var searchClearance =
        !isEmpty(clearanceStatus) && clearanceStatus.value
      var searchClientType = !isEmpty(clientType) ? clientType.value : ""
      var searchvalue = {}
      if (searchClientType) {
        searchvalue.clientType = searchClientType
      }
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      searchvalue.isOperationStatus = true
      if (searchEngage) {
        searchvalue.onlyEngagement = searchEngage
      }
      if (searchAgent) {
        searchvalue.employeeId = searchAgent
      }
      if (searchDataCopy) {
        searchvalue.dataCopyStatus = searchDataCopy
      }
      if (searchEvent) {
        searchvalue.eventNameId = searchEvent
      }
      if (searchEwName) {
        searchvalue.EWId = searchEwName
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }
      if (searchEmp) {
        searchvalue.empId = searchEmp
      }
      if (searchAssignedFromDate) {
        searchvalue.assignedFromDate = searchAssignedFromDate
      }
      if (searchAssignedToDate) {
        searchvalue.assignedToDate = searchAssignedToDate
      }

      if (searchGroom) {
        searchvalue.groomName = searchGroom
      }
      if (searchBride) {
        searchvalue.brideName = searchBride
      }
      if (searchProductName) {
        searchvalue.productCategoryId = searchProductName
      }
      if (searchDeliverable) {
        searchvalue.productionprocessstatus = searchDeliverable
      }
      if (searchClientCode) {
        searchvalue.clientCode = searchClientCode
      }
      if (searchClearance) {
        searchvalue.paymentType = searchClearance
      }
      if (searchInProgress) {
        searchvalue.subStatus = searchInProgress
      }
      if (searchOpenFollowup !== "" && searchOpenFollowup !== undefined && searchOpenFollowup !== null) {
        searchvalue.openFollowupCount = searchOpenFollowup
      }
      if (searchOperators) {
        searchvalue.openOperators = searchOperators
      }
      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(crmManageClientAction.loadCrmManageClient(searchvalue))
    } else {
      dispatch(
        crmManageClientAction.loadCrmManageClient({
          page: page,
          limit: sizePerPage,
          isOperationStatus: true,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  const handleClearModal = () => {
    setCrmData({ ...crmData, notes: "" })
    setMultiCrmData({ ...multiCrmData, note: "" })
    setEmployee([])
    setMultiEmployee([])
    setExpandCrmData({ ...expandCrmData, notes: "" })
    setUploadExpandCrmInput([])
    setFileExpandCrmLength("")
    setFileExpandCrmName("")
    setExpandEmployee([])
    setOperationStatus([])
    setOperationAttachment([])
    setProcessData({
      ...processData,
      notes: "",
    })
    setPlEmployee([])
  }
  const [uploadCrmInput, setUploadCrmInput] = useState([])
  const [fileCrmName, setFileCrmName] = useState("")
  const [fileCrmLength, setFileCrmLength] = useState("")

  const uploadCrmChange = async (e) => {
    if (e.target.files) {
      setUploadCrmInput(e.target.files)
      var file = e.target.files
      setFileCrmName(file[0].name)
      setFileCrmLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadCrmInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadCrmInput(teamUploadValue)
          }
        })
      }
    }
  }
  const [uploadExpandCrmInput, setUploadExpandCrmInput] = useState([])
  const [fileExpandCrmName, setFileExpandCrmName] = useState("")
  const [fileExpandCrmLength, setFileExpandCrmLength] = useState("")

  const uploadExpandCrmChange = async (e) => {
    if (e.target.files) {
      setUploadExpandCrmInput(e.target.files)
      var file = e.target.files
      setFileExpandCrmName(file[0].name)
      setFileExpandCrmLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadExpandCrmInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadExpandCrmInput(teamUploadValue)
          }
        })
      }
    }
  }
  const [uploadMultiCrmInput, setUploadMultiCrmInput] = useState([])
  const [fileMultiCrmName, setFileMultiCrmName] = useState("")
  const [fileMultiCrmLength, setFileMultiCrmLength] = useState("")

  const uploadMultiCrmChange = async (e) => {
    if (e.target.files) {
      setUploadMultiCrmInput(e.target.files)
      var file = e.target.files
      setFileMultiCrmName(file[0].name)
      setFileMultiCrmLength(file.length)
      var fileArrayDetails = Array.from(file)
      var teamUploadValue = uploadMultiCrmInput

      for (let x in fileArrayDetails) {
        const formData = new FormData()
        formData.append("file", fileArrayDetails[x])
        api.post("/image_upload", formData).then(async (res) => {
          if (res && res.data && res.data.data) {
            teamUploadValue.push(res.data.data)
            await setUploadMultiCrmInput(teamUploadValue)
          }
        })
      }
    }
  }
  const deliverableId =
    !isEmpty(crmAssignData) && crmAssignData.deliverableDetails.length > 0
      ? crmAssignData.deliverableDetails.map((m) => m._id)
      : []
  const submitCrm = () => {
    if (simpleCrmValidator.current.allValid()) {
      const crm_details = {
        notes: crmData.notes,
        attachments: uploadCrmInput,
        menuMode: 3,
        employeeId: [employee.value],
        leadAssignDetail: [
          {
            leadId: crmAssignData.leadId,
            leadDelivarableId: deliverableId,
          },
        ],
      }
      setCrmAssignModal(false)
      dispatch(crmManageClientAction.addCrmAssign(crm_details))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      }, 1000)
    } else {
      simpleCrmValidator.current.showMessages()
      forceUpdate(1)
      setCrmAssignModal(true)
    }
  }

  const crmLeadArray =
    !isEmpty(crmAssignDetails) && crmAssignDetails.length > 0
      ? crmAssignDetails.map((data) => {
        return {
          leadId: data.leadId ? data.leadId : "",
          leadDelivarableId: data.deliverableDetails
            ? data.deliverableDetails.map((m) => m._id)
            : [],
        }
      })
      : []

  const submitMultiCrm = () => {
    if (simpleEmpValidator.current.allValid()) {
      const crm_details = {
        notes: multiCrmData.note,
        attachments: uploadMultiCrmInput,
        menuMode: 3,
        employeeId: [multiEmployee.value],
        leadAssignDetail: crmLeadArray,
      }
      setMultiCrmModal(false)
      dispatch(crmManageClientAction.addCrmAssign(crm_details))
      setTimeout(() => {
        dispatch(crmManageClientAction.loadCrmManageClient(searchValue))

        setCrmAssignDetails([])
      }, 1000)
    } else {
      simpleEmpValidator.current.showMessages()
      forceUpdate(1)
      setMultiCrmModal(true)
    }
  }

  //
  const expandDeliverableId =
    !isEmpty(expandCrmDetails) && expandCrmDetails.length > 0
      ? expandCrmDetails.map((m) => m._id)
      : []

  const submitExpandCrm = () => {
    const crm_details = {
      notes: expandCrmData.notes,
      attachments: uploadExpandCrmInput,
      menuMode: 3,
      employeeId: [expandEmployee.value],
      leadAssignDetail: [
        {
          leadId: leadId,
          leadDelivarableId: expandDeliverableId,
        },
      ],
    }
    dispatch(crmManageClientAction.addCrmAssign(crm_details))
    setTimeout(() => {
      dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      setExpandCrmDetails([])
    }, 1000)
  }
  useEffect(() => {
    if (crmError) {
      toast.error(crmError, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        onClose: () => {
          dispatch(crmManageClientAction.crmReset())
        },
      })
    } else if (crmSuccess) {
      toast.success(crmSuccess, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
        onClose: () => {
          dispatch(crmManageClientAction.crmReset())
        },
      })
    }
  }, [crmError, crmSuccess])

  //DATE
  const date = moment().format("YYYY-MM-DD")
  //ADD CLEARANCE
  const addClearance = () => {
    const level =
      clearanceDetails.ecClearanceStatus === "PS22" &&
        clearanceDetails.ecClearanceStatusName === "LEVEL 1 APPROVED"
        ? "LEVEL2"
        : "LEVEL1"

    const applyClearance = {
      leadId: clearanceDetails.leadId,
      mode: level,
      type: "unpaid",
      clearanceDate: date,
      clearanceBy: empId,
      clearanceStatus: "PS21",
      remarks: "",
    }
    specificDispatch(crmManageClientAction.addClearance(applyClearance))
    setTimeout(() => {
      dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      setClearanceModal(false)
    }, 1000)
  }
  // const downloadAttachment = (attachmentValue) => {
  //   try {
  //     download(attachmentValue, "downloaded_image.jpg", "image/jpeg")
  //   } catch (error) {
  //
  //   }
  // }

  //   const downloadAttachment = () => {

  //     const apiUrl = "https://demoapi.alphaone.app/uploads/1698643512938_marguerite-729510_1280.jpg"
  //     // const headers = {
  //     //   'Content-Type':'application/json',
  //     //   'Access-Control-Allow-Origin':'*',
  //     //   'Access-Control-Allow-Methods':'GET, POST, PUT, DELETE, OPTIONS',
  //     //   'Access-Control-Allow-Headers':'Content-Type, Authorization'
  //     // }

  //     fetch(apiUrl, {
  //       method: "GET",
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': 'Bearer your-access-token', // Replace with your actual access token
  //         'Custom-Header': 'custom-value', // Add any custom headers as needed
  //       },
  //       mode: 'cors', // Set the mode to 'cors' to enable cross-origin requests
  //     })
  //       .then(response => {
  //         // Handle the response here
  //
  //       })
  //       .catch(error => {
  //         // Handle any errors
  //
  //       })

  //     // fetch("https://demoapi.alphaone.app/uploads/1698643512938_marguerite-729510_1280.jpg")
  //     //   .then(response => {

  //     //

  //     //   })
  // //     fetch("https://demoapi.alphaone.app/uploads/1698643512938_marguerite-729510_1280.jpg", {
  // //   method: "GET", // HTTP method (GET, POST, etc.)
  // //   mode: "cors", // Set the mode to "cors" to enable cross-origin requests

  // //   // Add the headers that you need to include to avoid CORS errors
  // //   headers: {
  // //     // Example header for authentication
  // //     "Custom-Header": "custom-value", // You can add additional headers as needed
  // //   },
  // // })

  //       // .then(blob => {
  //       //   const url = window.URL.createObjectURL(new Blob([blob]))
  //       //   const a = document.createElement('a')
  //       //   a.style.display = 'none'
  //       //   a.href = url
  //       //   a.download = 'your_file_name.jpg'// Specify the desired file name here
  //       //   document.body.appendChild(a)
  //       //   a.click()
  //       //   window.URL.revokeObjectURL(url)
  //       // })

  //       // .catch(error => {
  //       //
  //       // })
  //     // const blob = new Blob([image],{ type:"image/jpeg"})

  //     // const url = URL.createObjectURL(blob)
  //     //

  //     // const a = document.createElement('a')
  //     // a.style.display = 'none'

  //     // a.href = url
  //     // a.download = imageName

  //     // document.body.appendChild(a)
  //     // a.click()

  //     //saveAs(image,imageName)
  //   }
  //
  const downloadAttachment = (attachmentValue) => {
    saveAs(attachmentValue, "image.jpg")
  }
  const updateDormant = () => {
    const dormant_details = {
      leadId: leadId,
      dormantRemarks: dormantData.remarks,
    }

    dispatch(crmManageClientAction.updateDormant(dormant_details))
    setTimeout(() => {
      dispatch(crmManageClientAction.loadCrmManageClient(searchValue))
      setDormantModal(false)
      toast.success("Dormant Client Updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }, 1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Operation"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Lead No"}>
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          name="leadNo"
                          value={crmManageClientData.leadNo}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Lead No"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Client Code"}
                          >
                            {"ClientCode"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          name="clientCode"
                          value={crmManageClientData.clientCode}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Client Code"
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            recordsMetaData ? recordsMetaData.eventOptions : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={crmManageClientData.fromDate}
                          max={crmManageClientData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={crmManageClientData.toDate}
                          min={crmManageClientData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"CRM Name"}>
                            {"CRM Name"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="agent"
                          key={agentKey}
                          items={recordsMetaData.employeeOptions}
                          value={agent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setAgent(e)}
                          onChange={(e) => setAgent(e.target.value)}
                          onClear={() => setAgent([])}
                          placeholder="Enter CRM Name"
                          fuseOptions={fuseAgentOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Assigned From Date"}
                          >
                            {"CRM Assigned From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="assignedFromDate"
                          value={crmManageClientData.assignedFromDate}
                          max={crmManageClientData.assignedToDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Assigned To Date"}
                          >
                            {"CRM Assigned To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="assignedToDate"
                          value={crmManageClientData.assignedToDate}
                          min={crmManageClientData.assignedFromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Bride Name"}
                          >
                            {"Bride Name"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="brideName"
                          value={crmManageClientData.brideName}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Bride Name"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Groom Name"}
                          >
                            {"Groom Name"}
                          </Label>
                        </div>

                        <Input
                          type="text"
                          name="groomName"
                          value={crmManageClientData.groomName}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Groom Name"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Product Name"}
                          >
                            {"Product Name"}
                          </Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="products"
                          value={products}
                          // isMulti
                          onChange={(e) => setProducts(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.productOptions
                              : []
                          }
                          placeholder="Select Product"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Deliverable Status"}
                          </Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="deliverableStatus"
                          value={deliverableStatus}
                          // isMulti
                          onChange={(e) => setDeliverableStatus(e)}
                          options={
                            recordsMetaData
                              ? recordsMetaData.deliverOptions
                              : []
                          }
                          placeholder="Select Deliverable Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"CRM Name"}>
                            {"EW Name"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="ewName"
                          key={agentKey}
                          items={recordsMetaData.employeeOptions}
                          value={ewName}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEwName(e)}
                          onChange={(e) => setEwName(e.target.value)}
                          onClear={() => setEwName([])}
                          placeholder="Enter EW Name"
                          fuseOptions={fuseAgentOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Clearance Status"}
                          </Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="clearanceStatus"
                          value={clearanceStatus}
                          // isMulti
                          onChange={(e) => setClearanceStatus(e)}
                          options={[{ label: "Completed", value: "Completed" },
                          { label: "Partial Pending", value: "Partial_Pending" },
                          { label: "Pending", value: "Pending" },
                          { label: "Exception", value: "Exception" },
                          { label: "Complimentary", value: "Complimentary" },]
                          }
                          placeholder="Select Clearance Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Data Copy Status"}
                          </Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="dataCopyStatus"
                          value={dataCopyStatus}
                          onChange={(e) => setDataCopyStatus(e)}
                          options={
                            [{ label: "COMPLETED", value: "COMPLETED" },
                            { label: "PENDING", value: "PENDING" }
                            ]
                          }
                          placeholder="Select Data Copy Status"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-5 d-flex justify-content-between">
                        <Col>
                          <div className="d-flex flex-row">
                            {statusList.map((status, index) => {
                              return (
                                <div className="d-flex flex-row" key={index}>
                                  <Input
                                    type="checkbox"
                                    name="inProgress"
                                    value={status.value}
                                    checked={inProgress === status.value}
                                    onChange={(e) =>
                                      handleStatusChange(e, status.value)
                                    }
                                    className="font-size-15"
                                  />
                                  <Label
                                    className="mx-2"
                                    style={{ marginTop: "2px", fontSize: "12px" }}
                                  >
                                    {status.label}
                                  </Label>
                                </div>
                              )
                            })}
                          </div></Col>


                        <Col><div className="d-flex flex-row">
                          {statusListEngage.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="onlyEngagement"
                                  value={status.value}
                                  checked={onlyEngagement === status.value}
                                  onChange={(e) =>
                                    handleStatusEngageChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div></Col>

                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Open Operators"}
                          </Label>
                        </div>
                        <Select
                          isClearable={true}
                          type="text"
                          name="openOperators"
                          value={openOperators}
                          onChange={(e) => setOpenOperators(e)}
                          options={
                            [{ label: "= =", value: "==" },
                            { label: "<", value: "<" },
                            { label: ">", value: ">" },
                            { label: "< =", value: "<=" },
                            { label: "> =", value: ">=" },

                            ]
                          }
                          placeholder="Select Open Operators"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className={"form-label"}
                            htmlFor={"Bride Name"}
                          >
                            {"Open Followup Count"}
                          </Label>
                        </div>

                        <Input
                          type="number"
                          name="openFollowupCount"
                          value={crmManageClientData.openFollowupCount}
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Open Followup Count"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Type"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="clientType"
                          value={clientType}
                          onChange={(e) => setClientType(e)}
                          options={
                            [{ label: "Green", value: "Green" },
                            { label: "Orange", value: "Orange" },
                            { label: "Blue", value: "Blue" }]
                          }
                          placeholder="Select Client Type"
                          classNamePrefix="select2-selection"
                          isClearable={true}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={crmManageClientDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      crmManageClient_details.totalDataCount
                        ? crmManageClient_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {crmAssignModal && (
                    <Modal size="xl" show={crmAssignModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        CRM Assign
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}<span className="required">*</span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="employee"
                              value={employee}
                              onChange={(e) => setEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                            <div
                              style={{ textTransform: "capitalize" }}
                            >
                              {simpleCrmValidator.current.message(
                                "Employee",
                                employee,
                                "required"
                              )}
                            </div>
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="notes"
                              value={crmData.notes}
                              onChange={(e) => handleNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>
                              <Input
                                type="file"
                                name="uploadCrmInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                multiple
                                onChange={(e) => uploadCrmChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileCrmLength ? fileCrmLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileCrmName ? fileCrmName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setCrmAssignModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {

                            submitCrm()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiCrmModal && (
                    <Modal size="xl" show={multiCrmModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        CRM Assign
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"} <span className="required">*</span>
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="multiEmployee"
                              value={multiEmployee}
                              onChange={(e) => setMultiEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                            <div
                              style={{ textTransform: "capitalize" }}
                            >
                              {simpleEmpValidator.current.message(
                                "Employee",
                                multiEmployee,
                                "required"
                              )}
                            </div>
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiCrmData.note}
                              onChange={(e) => handleMultiNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>
                              <Input
                                type="file"
                                name="uploadMultiCrmInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                multiple
                                onChange={(e) => uploadMultiCrmChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileMultiCrmLength ? fileMultiCrmLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileMultiCrmName ? fileMultiCrmName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiCrmModal(false)
                            setCrmAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {

                            submitMultiCrm()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {crmExpandModal && (
                    <Modal size="xl" show={crmExpandModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        CRM Assign
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}
                              </Label>
                            </div>

                            <Select
                              type="text"
                              name="expandEmployee"
                              value={expandEmployee}
                              onChange={(e) => setExpandEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="notes"
                              value={expandCrmData.notes}
                              onChange={(e) => handleExpandNotes(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="4" md="4" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>
                              <Input
                                type="file"
                                name="uploadExpandCrmInput"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                multiple
                                onChange={(e) => uploadExpandCrmChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {fileExpandCrmLength ? fileExpandCrmLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {fileExpandCrmName ? fileExpandCrmName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setCrmExpandModal(false)
                            setExpandCrmDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setCrmExpandModal(false)
                            submitExpandCrm()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {historyModal && (
                    <Modal size="xl" show={historyModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Assigned History
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Type</th>
                                <th>Employee Name</th>
                                <th>Notes</th>
                                <th>Attachment</th>
                                <th>Created On</th>
                                <th>Created By</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(history_details) &&
                                history_details.data.length > 0 ? (
                                history_details.data.map((data, index) => {
                                  const employeeName =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.name
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].employeeId
                                          .map((employee) => employee.name)
                                          .join()
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].employeeId
                                            .map((employee) => employee.name)
                                            .join()
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].employeeId
                                              .map((employee) => employee.name)
                                              .join()
                                            : "--"

                                  const typeName = data.PrecrmId
                                    ? "CRM"
                                    : data.assignedTeamlead
                                      ? "PL"
                                      : data.assignCrmEmployee
                                        ? "CRM"
                                        : data.assignEmployee
                                          ? "EW"
                                          : "--"

                                  const notesName =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId) &&
                                      data.PrecrmId.notes
                                      ? data.PrecrmId.notes
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead) &&
                                        data.assignedTeamlead[0].notes !== ""
                                        ? data.assignedTeamlead[0].notes
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee) &&
                                          data.assignEmployee[0].notes !== ""
                                          ? data.assignEmployee[0].notes
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee) &&
                                            data.assignCrmEmployee[0].notes !== ""
                                            ? data.assignCrmEmployee[0].notes
                                            : "--"
                                  const createdOn =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId) &&
                                      data.PrecrmId.createdOn
                                      ? moment
                                        .utc(data.PrecrmId.createdOn)
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? moment
                                          .utc(
                                            data.assignedTeamlead[0].createdOn
                                          )
                                          .format(`${dateFormat} ${"hh:mm A"}`)
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? moment
                                            .utc(data.assignEmployee[0].createdOn)
                                            .format(`${dateFormat} ${"hh:mm A"}`)
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? moment
                                              .utc(
                                                data.assignCrmEmployee[0].createdOn
                                              )
                                              .format(`${dateFormat} ${"hh:mm A"}`)
                                            : "--"
                                  const createdBy =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.createdByName
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].createdByName
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].createdByName
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].createdByName
                                            : "--"
                                  const attachment =
                                    data.PrecrmId !== undefined &&
                                      !isEmpty(data.PrecrmId)
                                      ? data.PrecrmId.attachments
                                      : data.assignedTeamlead !== undefined &&
                                        !isEmpty(data.assignedTeamlead)
                                        ? data.assignedTeamlead[0].attachments
                                        : data.assignEmployee !== undefined &&
                                          !isEmpty(data.assignEmployee)
                                          ? data.assignEmployee[0].attachments
                                          : data.assignCrmEmployee !== undefined &&
                                            !isEmpty(data.assignCrmEmployee)
                                            ? data.assignCrmEmployee[0].attachments
                                            : "--"
                                  const attachmentValue = !isEmpty(attachment)
                                    ? attachment[0]
                                    : []
                                  const splitAttach = !isEmpty(attachmentValue)
                                    ? attachmentValue.split(".")
                                    : ""
                                  const attachExtension = !isEmpty(splitAttach)
                                    ? splitAttach.pop()
                                    : ""


                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{typeName}</td>
                                      <td>{employeeName}</td>
                                      <td>{notesName}</td>
                                      <td>
                                        {" "}
                                        {(attachmentValue &&
                                          attachExtension === "jpeg") ||
                                          (attachmentValue &&
                                            attachExtension === "jpg") ||
                                          (attachmentValue &&
                                            attachExtension === "png") ? (
                                          <div className="d-flex flex-row align-items-center">
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachmentValue,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>
                                            <div className="ms-auto ml-2">
                                              <a
                                                style={{
                                                  color: "#17b77d",
                                                }}
                                                //onClick={() => downloadAttachment(attachmentValue, attachmentValue, attachExtension)}
                                                // onClick={() => handleDownload()}
                                                onClick={() =>
                                                  downloadAttachment(
                                                    attachmentValue
                                                  )
                                                }
                                              >
                                                <i className="fa fa-download fa-lg"></i>
                                              </a>
                                            </div>
                                          </div>
                                        ) : (attachmentValue &&
                                          attachExtension === "mp3") ||
                                          (attachmentValue &&
                                            attachExtension === "m4a") ||
                                          (attachmentValue &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachmentValue}>
                                            <audio controls>
                                              <source
                                                src={attachmentValue}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>

                                      <td>{createdOn}</td>
                                      <td>{createdBy}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr key={0}>
                                  <td className="text-align-center" colSpan={7}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setHistoryModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiProductModal && (
                    <Modal size="xl" show={multiProductModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Product Lead
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"}<span className="required">*</span>
                              </Label>
                            </div>

                            <Select
                              isMulti
                              type="text"
                              name="multiProductEmployee"
                              value={multiProductEmployee}
                              onChange={(e) => setMultiProductEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                            <div style={{ textTransform: "capitalize" }}
                            >
                              {simpleProductValidator.current.message(
                                "Employee",
                                multiProductEmployee,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiProductData.note}
                              onChange={(e) => handleMultiProduct(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiProductFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiProductChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {productFileLength ? productFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {productFileName ? productFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiProductModal(false)
                            setProductAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            multiProductSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {deliverablesModal && (
                    <Modal size="xl" show={deliverablesModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Deliverables
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Mode</th>
                                <th>Tat Date</th>
                                <th>Link</th>
                                <th>Remarks</th>
                                <th>Attachment</th>
                                <th>Quantity</th>
                                <th>Created By</th>
                                <th>Created On</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(deliverablesData) &&
                                deliverablesData.length > 0 ? (
                                deliverablesData.map((data, index) => {
                                  const createdOn = !isEmpty(data.createdOn)
                                    ? moment
                                      .utc(data.createdOn)
                                      .format(`${dateFormat} ${"hh:mm A"}`)
                                    : "--"

                                  const attachment = !isEmpty(data.attachment)
                                    ? data.attachment.map((m) => m).join()
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  const tatDate = data.tat
                                    ? moment(data.tat).format(dateFormat)
                                    : "--"
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.mode ? data.mode : "--"}</td>
                                      <td>{tatDate}</td>
                                      <td>{data.link ? data.link : "--"}</td>
                                      <td>
                                        {data.remarks ? data.remarks : "--"}
                                      </td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                          <div className="d-flex flex-row align-items-center">
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachment,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>
                                            <div className="ms-auto ml-2">
                                              <span
                                                style={{
                                                  color: "#17b77d",
                                                }}
                                              >
                                                <i className="fa fa-download fa-lg"></i>
                                              </span>
                                            </div>
                                          </div>
                                        ) : (attachment &&
                                          attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>
                                        {data.quantity ? data.quantity : "--"}
                                      </td>
                                      <td>
                                        {data.employeeName
                                          ? data.employeeName
                                          : "--"}
                                      </td>
                                      <td>{createdOn}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td className="text-align-center" colSpan={9}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setDeliverablesModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiTeamModal && (
                    <Modal size="xl" show={multiTeamModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Team
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Follow-Up-Date"}
                              >
                                {"Employee"} <span className="required">*</span>
                              </Label>
                            </div>

                            <Select
                              isMulti
                              type="text"
                              name="multiTeamEmployee"
                              value={multiTeamEmployee}
                              onChange={(e) => setMultiTeamEmployee(e)}
                              options={
                                recordsMetaData
                                  ? recordsMetaData.employeeOptions
                                  : []
                              }
                              placeholder="Select Employee"
                              classNamePrefix="select2-selection"
                            />
                            <div
                              style={{ textTransform: "capitalize" }}
                            >
                              {simpleEwValidator.current.message(
                                "Employee",
                                multiTeamEmployee,
                                "required"
                              )}
                            </div>
                          </Col>
                          <Col md="5" lg="5" xl="5" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="note"
                              value={multiTeamData.note}
                              onChange={(e) => handleMultiTeam(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col lg="2" md="2" sm="12" xs="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Button className=" btn btn-warning  position-relative fs-5">
                              <i className="fas fa-laptop"></i>

                              <Input
                                type="file"
                                name="multiTeamFile"
                                accept="application/pdf, audio/mp3 , image/jpeg"
                                // id="upload-btn"
                                multiple
                                onChange={(e) => multiTeamChange(e)}
                                style={{
                                  position: "absolute",
                                  fontSize: "50px",
                                  opacity: 0,
                                  right: 0,
                                  top: 0,
                                }}
                              />
                              <span className="position-absolute top-0 start-100 translate-middle  badge bg-danger  rounded-circle">
                                {teamFileLength ? teamFileLength : 0}
                              </span>
                            </Button>
                            <div className="text-decoration-underline text-danger">
                              {teamFileName ? teamFileName : ""}
                            </div>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setMultiTeamModal(false)
                            setTeamAssignDetails([])
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            teamMultipleSubmit()
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {clearanceModal && (
                    <Modal show={clearanceModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Clearance Report</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Do You Want To Clearance The Report?
                      </Modal.Body>

                      <Modal.Footer>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setClearanceModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setClearanceModal(false)
                              addClearance()
                            }}
                            style={{ marginLeft: "20px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {clearanceHistoryModal && (
                    <Modal
                      show={clearanceHistoryModal}
                      size="lg"
                      backdrop="static"
                    >
                      <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
                        <h5 style={{ color: "white" }}>
                          Clearance Status History
                        </h5>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered striped responsive>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Clearance Date</th>
                                  <th>Payment Status</th>
                                  <th>Level</th>
                                  <th>Payment %</th>
                                  <th>Remarks</th>
                                  <th>Attachment</th>
                                  <th>Status</th>
                                  <th>Created By</th>
                                  <th>Created On</th>
                                </tr>
                              </thead>
                              <tbody>
                                {clearanceHistoryDetails &&
                                  clearanceHistoryDetails.length > 0 ? (
                                  clearanceHistoryDetails.map((data, index) => {
                                    const attachmentValue = !isEmpty(
                                      data.attachment
                                    )
                                      ? data.attachment
                                      : []
                                    const splitAttach = !isEmpty(
                                      attachmentValue
                                    )
                                      ? attachmentValue.split(".")
                                      : ""
                                    const attachExtension = !isEmpty(
                                      splitAttach
                                    )
                                      ? splitAttach.pop()
                                      : ""
                                    const clearanceDate = !isEmpty(
                                      data.clearanceDate
                                    )
                                      ? moment(data.clearanceDate)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : "--"
                                    const createdAt = !isEmpty(data.CreatedOn)
                                      ? moment(data.CreatedOn)
                                        .subtract(5, "hours")
                                        .subtract(30, "minutes")
                                        .format(`${dateFormat} ${"hh:mm A"}`)
                                      : "--"
                                    const processStatusName =
                                      !isEmpty(recordsMetaData) &&
                                        !isEmpty(
                                          recordsMetaData.processStatusOptions
                                        ) &&
                                        recordsMetaData.processStatusOptions &&
                                        recordsMetaData.processStatusOptions
                                          .length > 0
                                        ? recordsMetaData.processStatusOptions.find(
                                          (_) =>
                                            _.processStatusId ==
                                            data.clearanceStatus
                                        )
                                        : "--"
                                    const btnColor =
                                      data.paymentType === "paid"
                                        ? "btn-success"
                                        : data.paymentType ===
                                          "complementary" ||
                                          data.paymentType === "Complementary"
                                          ? "btn-info"
                                          : data.paymentType === "Exception" ||
                                            data.paymentType === "exception"
                                            ? "btn-warning"
                                            : data.paymentType === "unpaid"
                                              ? "btn-danger"
                                              : data.paymentType === "partialpaid"
                                                ? ""
                                                : "btn-danger"

                                    const btnStyle =
                                      data.paymentType === "partialpaid"
                                        ? {
                                          backgroundColor: "#f9851b",
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "4px 6px",
                                          borderRadius: "4px",
                                        }
                                        : {
                                          border: "none",
                                          cursor: "pointer",
                                          color: "white",
                                          padding: "4px 6px",
                                          borderRadius: "4px",
                                        }
                                    return (
                                      <>
                                        <tr key={data._id}>
                                          <td>{index + 1}</td>
                                          <td>{clearanceDate}</td>
                                          <td>
                                            {data.paymentType
                                              ? data.paymentType
                                              : "--"}
                                          </td>
                                          <td>
                                            {data.mode ? data.mode : "--"}
                                          </td>
                                          <td>
                                            {data.paymentReceivedPercentage
                                              ? data.paymentReceivedPercentage
                                              : "--"}
                                          </td>

                                          <td>
                                            {data.remarks ? data.remarks : "--"}
                                          </td>
                                          <td>
                                            {" "}
                                            {(attachmentValue &&
                                              attachExtension === "jpeg") ||
                                              (attachmentValue &&
                                                attachExtension === "jpg") ||
                                              (attachmentValue &&
                                                attachExtension === "png") ? (
                                              <a
                                                onClick={() =>
                                                  window.open(
                                                    attachmentValue,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                    color: "#E40D8C",
                                                  }}
                                                >
                                                  View
                                                </span>
                                              </a>
                                            ) : (attachmentValue &&
                                              attachExtension === "mp3") ||
                                              (attachmentValue &&
                                                attachExtension === "m4a") ||
                                              (attachmentValue &&
                                                attachExtension === "mp4") ? (
                                              <a href={attachmentValue}>
                                                <audio controls>
                                                  <source
                                                    src={attachmentValue}
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser does not support
                                                  the audio element.
                                                </audio>
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </td>
                                          <td>
                                            <button
                                              className={`btn ${btnColor}`}
                                              style={btnStyle}
                                            >
                                              {processStatusName.label}
                                            </button>
                                          </td>
                                          <td>
                                            {data.insertedByName
                                              ? data.insertedByName
                                              : "--"}
                                          </td>
                                          <td>{createdAt}</td>
                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={10}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setClearanceHistoryModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {/* {dataModal && (
                    <Modal show={dataModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Update Data Detail</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Do You Want To Update Data Detail?
                      </Modal.Body>

                      <Modal.Footer>
                        <div>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDataModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setDataModal(false)
                              updateData()
                            }}
                            style={{ marginLeft: "20px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )} */}
                  {unassignedModal && (
                    <Modal show={unassignedModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Confirm</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Are you sure , You want to Unassigned?
                      </Modal.Body>
                      <Modal.Footer>
                        <div>
                          <Button
                            // type="submit"
                            onClick={() => {
                              setUnassignedModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setUnassignedModal(false)
                              addUnAssign()
                            }}
                            style={{ marginLeft: "10px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {multiUnAssignModal && (
                    <Modal show={multiUnAssignModal} size="md">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <div className="d-flex flex-row">
                          <span>Confirm</span>
                        </div>
                      </Modal.Header>
                      <Modal.Body>
                        Are you sure , You want to Unassigned?
                      </Modal.Body>
                      <Modal.Footer>
                        <div>
                          <Button
                            // type="submit"
                            onClick={() => {
                              setMultiUnAssignModal(false)
                            }}
                            className="btn btn-danger buttons"
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            onClick={() => {
                              setMultiUnAssignModal(false)
                              addMultiUnAssign()
                            }}
                            style={{ marginLeft: "10px" }}
                            className="btn btn-success buttons"
                          >
                            {" "}
                            Confirm
                          </Button>
                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {processStatusModal && (
                    <Modal size="xl" show={processStatusModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Deliverable Status
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-2">
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label
                                className="form-label"
                                htmlFor={"Process Status"}
                              >
                                {"Operation Status"}
                              </Label>
                            </div>

                            <Select
                              // isMulti
                              type="text"
                              name="operationStatus"
                              value={operationStatus}
                              onChange={(e) => setOperationStatus(e)}
                              options={operationStatusOptions}
                              placeholder="Select Operation Status"
                              classNamePrefix="select2-selection"
                            />
                          </Col>

                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Notes"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="notes"
                              value={processData.notes}
                              onChange={(e) => handleNotesChange(e)}
                              placeholder="Enter Notes"
                            />
                          </Col>
                          <Col md="4" lg="4" xl="4" sm="12">
                            <div className="d-flex justify-content-between">
                              <Label className={"form-label"} htmlFor={"Notes"}>
                                {"Attachment (JPG/PNG)"}
                              </Label>
                            </div>
                            <Input
                              type="file"
                              name="operationAttachment"
                              onChange={(e) => operationAttachmentChange(e)}
                              placeholder="Attach the files"
                              multiple
                            />
                          </Col>
                          {operationStatus.value === "PS46" &&
                            printable === true && (
                              <>
                                <Row>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Notes"}
                                      >
                                        {"Assign Print Pl"}{" "}
                                        <span className="required">*</span>
                                      </Label>
                                    </div>
                                    <Select
                                      type="text"
                                      isMulti
                                      name="plEmployee"
                                      value={plEmployee}
                                      onChange={(e) => setPlEmployee(e)}
                                      options={recordsMetaData.employeeOptions}
                                      placeholder="Select Assign Print Pl"
                                      classNamePrefix="select2-selection"
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {simpleValidator.current.message(
                                        "Assign Print Pl",
                                        plEmployee,
                                        "required"
                                      )}
                                    </div>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"No Of Sheets"}
                                      >
                                        {"No Of Sheets"}{" "}
                                        <span className="required">*</span>
                                      </Label>
                                    </div>
                                    <Input
                                      type="text"
                                      name="noOfSheets"
                                      value={printPlData.noOfSheets}
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter No Of Sheets"
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {simpleValidator.current.message(
                                        "No Of Sheets",
                                        printPlData.noOfSheets,
                                        "required"
                                      )}
                                    </div>
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"No Of Wrapper Sheets"}
                                      >
                                        {"No Of Wrapper Sheets"}{" "}
                                        <span className="required">*</span>
                                      </Label>
                                    </div>
                                    <Input
                                      type="text"
                                      name="noOfWrapperSheets"
                                      value={printPlData.noOfWrapperSheets}
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter No Of Wrapper Sheets"
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {simpleValidator.current.message(
                                        "No Of Wrapper Sheets",
                                        printPlData.noOfWrapperSheets,
                                        "required"
                                      )}
                                    </div>
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Print File Link"}
                                      >
                                        {"Print File Link"}{" "}
                                        <span className="required">*</span>
                                      </Label>
                                    </div>
                                    <Input
                                      type="text"
                                      name="printFileLink"
                                      value={printPlData.printFileLink}
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter Print File Link"
                                    />
                                    <div
                                      style={{ textTransform: "capitalize" }}
                                    >
                                      {simpleValidator.current.message(
                                        "Print File Link",
                                        printPlData.printFileLink,
                                        "required"
                                      )}
                                    </div>
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Additional Product Remarks"}
                                      >
                                        {"Additional Product Remarks"}
                                      </Label>
                                    </div>
                                    <Input
                                      type="textarea"
                                      name="additionalProductRemarks"
                                      value={
                                        printPlData.additionalProductRemarks
                                      }
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter Addditional Product Remarks"
                                    />
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Package Inclusion Number"}
                                      >
                                        {"Package Inclusion Number"}
                                      </Label>
                                    </div>
                                    <Input
                                      type="text"
                                      name="packageInclusionNumber"
                                      value={printPlData.packageInclusionNumber}
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter Package Inclusion Number"
                                    />
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Package Inclusion Number"}
                                      >
                                        {"Package Inclusion Remarks"}
                                      </Label>
                                    </div>
                                    <Input
                                      type="textarea"
                                      name="packegeInclusionRemarks"
                                      value={
                                        printPlData.packegeInclusionRemarks
                                      }
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter Package Inclusion Remarks"
                                    />
                                  </Col>
                                  <Col
                                    md="4"
                                    lg="4"
                                    xl="4"
                                    sm="12"
                                    className="mt-3"
                                  >
                                    <div className="d-flex justify-content-between">
                                      <Label
                                        className={"form-label"}
                                        htmlFor={"Delivery Address"}
                                      >
                                        {"Delivery Address"}
                                      </Label>
                                    </div>
                                    <Input
                                      type="textarea"
                                      name="deliveryAddress"
                                      value={printPlData.deliveryAddress}
                                      onChange={(e) => handlePrintChange(e)}
                                      placeholder="Enter Delivery Address"
                                    />
                                  </Col>
                                </Row>
                              </>
                            )}
                        </Row>
                        <Row className="quote-head-content">
                          <Col md="6" lg="6" sm="12">
                            <p className="quote-head">Process Status History</p>
                          </Col>
                        </Row>
                        <Row>
                          <Table responsive>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Mode</th>
                                <th>Employee Name</th>
                                <th>Deliverable Status</th>
                                <th>Notes</th>
                                <th>Attachment</th>
                                <th>Created By</th>
                                <th>Created On</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(processHistoryDetails) &&
                                processHistoryDetails.length > 0 ? (
                                processHistoryDetails.map((data, index) => {
                                  const createdOn = !isEmpty(data.createdOn)
                                    ? moment(data.createdOn)
                                      .subtract(5, "hours")
                                      .subtract(30, "minutes")
                                      .format(`${dateFormat} ${"hh:mm A"}`)
                                    : "--"
                                  const empName =
                                    data.employeeName && data.employeeCode
                                      ? data.employeeCode +
                                      "-" +
                                      data.employeeName
                                      : "--"
                                  const attachment = !isEmpty(data.attachment)
                                    ? data.attachment.map((m) => m).join()
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.mode ? data.mode : "--"}</td>
                                      <td>{empName}</td>
                                      <td>
                                        {data.productioProcessStatusName
                                          ? data.productioProcessStatusName
                                          : "--"}
                                      </td>
                                      <td>{data.notes ? data.notes : "--"}</td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                          <a
                                            onClick={() =>
                                              window.open(attachment, "_blank")
                                            }
                                          >
                                            <span
                                              style={{
                                                textDecoration: "underline",
                                                color: "#E40D8C",
                                              }}
                                            >
                                              View
                                            </span>
                                          </a>
                                        ) : (attachment &&
                                          attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>
                                        {data.createdByName
                                          ? data.createdByName
                                          : "--"}
                                      </td>
                                      <td>{createdOn}</td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr>
                                  <td className="text-align-center" colSpan={8}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setProcessStatusModal(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          variant="secondary"
                          className={"btn btn-success"}
                          data-bs-dismiss="modal"
                          onClick={(e) => {
                            if (
                              operationStatus.value === "PS46" &&
                              printable === true
                            ) {
                              printSubmit(e)
                            } else {
                              processSubmit(e)
                            }
                          }}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {clientEventModal && (
                    <Modal size="xl" show={clientEventModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Event
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col md="12" lg="12" xl="12" className="mt-3">
                            <PaginationProvider
                              pagination={paginationFactory(clientOptions)}
                              keyField="index"
                              columns={clientColumns}
                            >
                              {({ paginationProps, paginationTableProps }) => (
                                <ToolkitProvider
                                  keyField="index"
                                  data={clientDataTable}
                                  columns={clientColumns}
                                  search
                                  exportCSV
                                >
                                  {(props) => (
                                    <div>
                                      <Col
                                        md="12"
                                        xl="12"
                                        lg="12"
                                        sm="12"
                                        xs="12"
                                      >
                                        <Row className="d-flex flex-row  ">
                                          <Col>
                                            <BootstrapTable
                                              {...props.baseProps}
                                              responsive
                                              striped={true}
                                              bordered={true}
                                              keyField="index"
                                              expandRow={clientExpandRow}
                                              columns={clientColumns}
                                              {...paginationTableProps}
                                            />
                                          </Col>
                                        </Row>
                                        <Row
                                          style={{ marginTop: "5px" }}
                                          className="align-items-md-center mt-30"
                                        >
                                          <Col className="inner-custom-pagination d-flex">
                                            <div className="d-inline d-flex flex-row">
                                              <SizePerPageDropdownStandalone
                                                {...paginationProps}
                                              />
                                              <div
                                                style={{
                                                  fontSize: "14px",
                                                  marginTop: "8px",
                                                  marginLeft: "4px",
                                                }}
                                              >
                                                <PaginationTotalStandalone
                                                  {...paginationProps}
                                                />
                                              </div>
                                            </div>
                                            <div
                                              className="text-md-right ms-auto"
                                              style={{ zIndex: 0 }}
                                            >
                                              <PaginationListStandalone
                                                {...paginationProps}
                                              />
                                            </div>
                                          </Col>
                                        </Row>
                                      </Col>
                                    </div>
                                  )}
                                </ToolkitProvider>
                              )}
                            </PaginationProvider>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setClientEventModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {eventServiceModal && (
                    <Modal show={eventServiceModal} size="xl">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Event
                      </Modal.Header>
                      <Modal.Body>
                        <Col md="12" lg="12" xl="12" className="mt-3">
                          <BootstrapTable
                            responsive
                            striped={true}
                            bordered={true}
                            keyField="index"
                            data={deliverDataTable}
                            columns={eventColumns}
                          />
                        </Col>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          onClick={() => updateMainEvent()}
                        >
                          Update
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setEventServiceModal(false)}
                        >
                          Cancel
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {dormantModal && (
                    <Modal size="md" show={dormantModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Dormant Client Update
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mb-5">
                          <Col md="12" lg="12" xl="12" sm="12" className="mt-1">
                            <div className="d-flex justify-content-between">
                              <Label
                                className={"form-label"}
                                htmlFor={"remarks"}
                              >
                                {"Remarks"}
                              </Label>
                            </div>
                            <Input
                              type="textarea"
                              name="remarks"
                              value={dormantData.remarks}
                              onChange={(e) => handleDormantChange(e)}
                              placeholder="Enter Remarks"
                            />
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setDormantModal(false)}
                        >
                          Cancel
                        </Button>

                        <Button
                          type="submit"
                          variant="secondary"
                          className={"btn btn-success"}
                          data-bs-dismiss="modal"
                          onClick={(e) => updateDormant(e)}
                        >
                          update
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {alertModal && (
                    <Modal size="md" show={alertModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Alert
                      </Modal.Header>
                      <Modal.Body>
                        Please Complete The Payment Status.
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setAlertModal(false)}
                        >
                          Close
                        </Button>

                      </Modal.Footer>
                    </Modal>
                  )}
                  {copyAlertModal && (
                    <Modal size="md" show={copyAlertModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Alert
                      </Modal.Header>
                      <Modal.Body>
                        Data Copy Status Is Not Completed.
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setCopyAlertModal(false)}
                        >
                          Close
                        </Button>

                      </Modal.Footer>
                    </Modal>
                  )}
                  {commonAlertModal && (
                    <Modal size="md" show={commonAlertModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Alert
                      </Modal.Header>
                      <Modal.Body>
                        Both Payment Status And Data Copy Status Is Not Completed.
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setCommonAlertModal(false)}
                        >
                          Close
                        </Button>

                      </Modal.Footer>
                    </Modal>
                  )}
                  {ecAttachmentModal && (
                    <Modal
                      show={ecAttachmentModal}
                      size="lg"
                      backdrop="static"
                    >
                      <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
                        <h5 style={{ color: "white" }}>
                          EC Confirmation Call
                        </h5>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered striped responsive>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Attchment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {ecAttachmentDetails &&
                                  ecAttachmentDetails.length > 0 ? (
                                  ecAttachmentDetails.map((data, index) => {
                                    const attachmentValue = !isEmpty(
                                      data.attachment
                                    )
                                      ? data.attachment[0]
                                      : []
                                    const splitAttach = !isEmpty(
                                      attachmentValue
                                    )
                                      ? attachmentValue.split(".")
                                      : ""
                                    const attachExtension = !isEmpty(
                                      splitAttach
                                    )
                                      ? splitAttach.pop()
                                      : ""

                                    return (
                                      <>
                                        <tr key={data._id}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {" "}
                                            {(attachmentValue &&
                                              attachExtension === "jpeg") ||
                                              (attachmentValue &&
                                                attachExtension === "jpg") ||
                                              (attachmentValue &&
                                                attachExtension === "png") ? (
                                              <a
                                                onClick={() =>
                                                  window.open(
                                                    attachmentValue,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                    color: "#E40D8C",
                                                  }}
                                                >
                                                  View
                                                </span>
                                              </a>
                                            ) : (attachmentValue &&
                                              attachExtension === "mp3") ||
                                              (attachmentValue &&
                                                attachExtension === "m4a") ||
                                              (attachmentValue &&
                                                attachExtension === "mp4") ? (
                                              <a href={attachmentValue}>
                                                <audio controls>
                                                  <source
                                                    src={attachmentValue}
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser does not support
                                                  the audio element.
                                                </audio>
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </td>

                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={2}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setEcAttachmentModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {salesAttachmentModal && (
                    <Modal
                      show={salesAttachmentModal}
                      size="lg"
                      backdrop="static"
                    >
                      <Modal.Header style={{ backgroundColor: "#E40D8C" }}>
                        <h5 style={{ color: "white" }}>
                          Sales Confirmation Call
                        </h5>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <Col lg="12" md="12" sm="12" xs="12">
                            <Table bordered striped responsive>
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Attchment</th>
                                </tr>
                              </thead>
                              <tbody>
                                {salesAttachmentDetails &&
                                  salesAttachmentDetails.length > 0 ? (
                                  salesAttachmentDetails.map((data, index) => {
                                    const attachmentValue = !isEmpty(
                                      data.recordAttachment
                                    )
                                      ? data.recordAttachment[0]
                                      : []
                                    const splitAttach = !isEmpty(
                                      attachmentValue
                                    )
                                      ? attachmentValue.split(".")
                                      : ""
                                    const attachExtension = !isEmpty(
                                      splitAttach
                                    )
                                      ? splitAttach.pop()
                                      : ""

                                    return (
                                      <>
                                        <tr key={data._id}>
                                          <td>{index + 1}</td>
                                          <td>
                                            {" "}
                                            {(attachmentValue &&
                                              attachExtension === "jpeg") ||
                                              (attachmentValue &&
                                                attachExtension === "jpg") ||
                                              (attachmentValue &&
                                                attachExtension === "png") ? (
                                              <a
                                                onClick={() =>
                                                  window.open(
                                                    attachmentValue,
                                                    "_blank"
                                                  )
                                                }
                                              >
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                    color: "#E40D8C",
                                                  }}
                                                >
                                                  View
                                                </span>
                                              </a>
                                            ) : (attachmentValue &&
                                              attachExtension === "mp3") ||
                                              (attachmentValue &&
                                                attachExtension === "m4a") ||
                                              (attachmentValue &&
                                                attachExtension === "mp4") ? (
                                              <a href={attachmentValue}>
                                                <audio controls>
                                                  <source
                                                    src={attachmentValue}
                                                    type="audio/mpeg"
                                                  />
                                                  Your browser does not support
                                                  the audio element.
                                                </audio>
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </td>

                                        </tr>
                                      </>
                                    )
                                  })
                                ) : (
                                  <tr key={0}>
                                    <td
                                      colSpan={2}
                                      className="text-align-center"
                                    >
                                      {"No Data Found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </Table>
                          </Col>
                        </Row>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          onClick={() => setSalesAttachmentModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {isEscalationModal && (
                    <Modal size="md" show={isEscalationModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Confirm
                      </Modal.Header>
                      <Modal.Body>
                        {`Are You Sure Do You Want To ${escalationRemove == true ? "Remove" : "Update"} IsEscalation ?`}

                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setIsEscalationModal(false)}
                        >
                          No
                        </Button>
                        <Button
                          variant="secondary"
                          className="btn btn-success"
                          data-bs-dismiss="modal"
                          onClick={() => updateEscalation()}
                        >
                          Yes
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

CrmManageClientDetails.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  csvProps: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CrmManageClientDetails)
)
